// Import real DC events
import { DC_REAL_EVENTS } from './dcRealEvents';

// Generated 288 comprehensive sample events
const SAMPLE_EVENTS = [
  {
    id: 'social-parties-morning-today-0',
    name: 'Today Morning Parties Party',
    description: 'Join us for an amazing morning party focused on parties. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Community Center',
    address: '100 Community Center St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: 'Free',
    attendees: 20,
    maxAttendees: 50,
    organizer: 'Social Network',
    tags: ["parties","morning","today"],
    website: 'https://example.com/social-parties-morning-today-0'
  },
  {
    id: 'social-parties-morning-tomorrow-1',
    name: 'Tomorrow Morning Parties Party',
    description: 'Join us for an amazing morning party focused on parties. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Social Club',
    address: '101 Social Club St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$10',
    attendees: 21,
    maxAttendees: 51,
    organizer: 'Social Network',
    tags: ["parties","morning","tomorrow"],
    website: 'https://example.com/social-parties-morning-tomorrow-1'
  },
  {
    id: 'social-parties-morning-this week-2',
    name: 'This Week Morning Parties Party',
    description: 'Join us for an amazing morning party focused on parties. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Restaurant',
    address: '102 Restaurant St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$15',
    attendees: 22,
    maxAttendees: 52,
    organizer: 'Social Network',
    tags: ["parties","morning","this week"],
    website: 'https://example.com/social-parties-morning-this week-2'
  },
  {
    id: 'social-parties-morning-weekend-3',
    name: 'Weekend Morning Parties Party',
    description: 'Join us for an amazing morning party focused on parties. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Park',
    address: '103 Park St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$20',
    attendees: 23,
    maxAttendees: 53,
    organizer: 'Social Network',
    tags: ["parties","morning","weekend"],
    website: 'https://example.com/social-parties-morning-weekend-3'
  },
  {
    id: 'social-parties-afternoon-today-4',
    name: 'Today Afternoon Parties Party',
    description: 'Join us for an amazing afternoon party focused on parties. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Event Space',
    address: '104 Event Space St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$25',
    attendees: 24,
    maxAttendees: 54,
    organizer: 'Social Network',
    tags: ["parties","afternoon","today"],
    website: 'https://example.com/social-parties-afternoon-today-4'
  },
  {
    id: 'social-parties-afternoon-tomorrow-5',
    name: 'Tomorrow Afternoon Parties Party',
    description: 'Join us for an amazing afternoon party focused on parties. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Community Center',
    address: '105 Community Center St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$30',
    attendees: 25,
    maxAttendees: 55,
    organizer: 'Social Network',
    tags: ["parties","afternoon","tomorrow"],
    website: 'https://example.com/social-parties-afternoon-tomorrow-5'
  },
  {
    id: 'social-parties-afternoon-this week-6',
    name: 'This Week Afternoon Parties Party',
    description: 'Join us for an amazing afternoon party focused on parties. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Social Club',
    address: '106 Social Club St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$35',
    attendees: 26,
    maxAttendees: 56,
    organizer: 'Social Network',
    tags: ["parties","afternoon","this week"],
    website: 'https://example.com/social-parties-afternoon-this week-6'
  },
  {
    id: 'social-parties-afternoon-weekend-7',
    name: 'Weekend Afternoon Parties Party',
    description: 'Join us for an amazing afternoon party focused on parties. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Restaurant',
    address: '107 Restaurant St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$50',
    attendees: 27,
    maxAttendees: 57,
    organizer: 'Social Network',
    tags: ["parties","afternoon","weekend"],
    website: 'https://example.com/social-parties-afternoon-weekend-7'
  },
  {
    id: 'social-parties-evening-today-8',
    name: 'Today Evening Parties Party',
    description: 'Join us for an amazing evening party focused on parties. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Park',
    address: '108 Park St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$75',
    attendees: 28,
    maxAttendees: 58,
    organizer: 'Social Network',
    tags: ["parties","evening","today"],
    website: 'https://example.com/social-parties-evening-today-8'
  },
  {
    id: 'social-parties-evening-tomorrow-9',
    name: 'Tomorrow Evening Parties Party',
    description: 'Join us for an amazing evening party focused on parties. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Event Space',
    address: '109 Event Space St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$100',
    attendees: 29,
    maxAttendees: 59,
    organizer: 'Social Network',
    tags: ["parties","evening","tomorrow"],
    website: 'https://example.com/social-parties-evening-tomorrow-9'
  },
  {
    id: 'social-parties-evening-this week-10',
    name: 'This Week Evening Parties Party',
    description: 'Join us for an amazing evening party focused on parties. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Community Center',
    address: '110 Community Center St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: 'Free',
    attendees: 30,
    maxAttendees: 60,
    organizer: 'Social Network',
    tags: ["parties","evening","this week"],
    website: 'https://example.com/social-parties-evening-this week-10'
  },
  {
    id: 'social-parties-evening-weekend-11',
    name: 'Weekend Evening Parties Party',
    description: 'Join us for an amazing evening party focused on parties. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Social Club',
    address: '111 Social Club St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$10',
    attendees: 31,
    maxAttendees: 61,
    organizer: 'Social Network',
    tags: ["parties","evening","weekend"],
    website: 'https://example.com/social-parties-evening-weekend-11'
  },
  {
    id: 'social-parties-night-today-12',
    name: 'Today Night Parties Party',
    description: 'Join us for an amazing night party focused on parties. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Restaurant',
    address: '112 Restaurant St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$15',
    attendees: 32,
    maxAttendees: 62,
    organizer: 'Social Network',
    tags: ["parties","night","today"],
    website: 'https://example.com/social-parties-night-today-12'
  },
  {
    id: 'social-parties-night-tomorrow-13',
    name: 'Tomorrow Night Parties Party',
    description: 'Join us for an amazing night party focused on parties. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Park',
    address: '113 Park St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$20',
    attendees: 33,
    maxAttendees: 63,
    organizer: 'Social Network',
    tags: ["parties","night","tomorrow"],
    website: 'https://example.com/social-parties-night-tomorrow-13'
  },
  {
    id: 'social-parties-night-this week-14',
    name: 'This Week Night Parties Party',
    description: 'Join us for an amazing night party focused on parties. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Event Space',
    address: '114 Event Space St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$25',
    attendees: 34,
    maxAttendees: 64,
    organizer: 'Social Network',
    tags: ["parties","night","this week"],
    website: 'https://example.com/social-parties-night-this week-14'
  },
  {
    id: 'social-parties-night-weekend-15',
    name: 'Weekend Night Parties Party',
    description: 'Join us for an amazing night party focused on parties. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Parties',
    venue: 'Community Center',
    address: '115 Community Center St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$30',
    attendees: 35,
    maxAttendees: 65,
    organizer: 'Social Network',
    tags: ["parties","night","weekend"],
    website: 'https://example.com/social-parties-night-weekend-15'
  },
  {
    id: 'social-meetups-morning-today-16',
    name: 'Today Morning Meetups Meetup',
    description: 'Join us for an amazing morning meetup focused on meetups. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Social Club',
    address: '116 Social Club St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$35',
    attendees: 36,
    maxAttendees: 66,
    organizer: 'Social Network',
    tags: ["meetups","morning","today"],
    website: 'https://example.com/social-meetups-morning-today-16'
  },
  {
    id: 'social-meetups-morning-tomorrow-17',
    name: 'Tomorrow Morning Meetups Meetup',
    description: 'Join us for an amazing morning meetup focused on meetups. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Restaurant',
    address: '117 Restaurant St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$50',
    attendees: 37,
    maxAttendees: 67,
    organizer: 'Social Network',
    tags: ["meetups","morning","tomorrow"],
    website: 'https://example.com/social-meetups-morning-tomorrow-17'
  },
  {
    id: 'social-meetups-morning-this week-18',
    name: 'This Week Morning Meetups Meetup',
    description: 'Join us for an amazing morning meetup focused on meetups. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Park',
    address: '118 Park St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$75',
    attendees: 38,
    maxAttendees: 68,
    organizer: 'Social Network',
    tags: ["meetups","morning","this week"],
    website: 'https://example.com/social-meetups-morning-this week-18'
  },
  {
    id: 'social-meetups-morning-weekend-19',
    name: 'Weekend Morning Meetups Meetup',
    description: 'Join us for an amazing morning meetup focused on meetups. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Event Space',
    address: '119 Event Space St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$100',
    attendees: 39,
    maxAttendees: 69,
    organizer: 'Social Network',
    tags: ["meetups","morning","weekend"],
    website: 'https://example.com/social-meetups-morning-weekend-19'
  },
  {
    id: 'social-meetups-afternoon-today-20',
    name: 'Today Afternoon Meetups Meetup',
    description: 'Join us for an amazing afternoon meetup focused on meetups. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Community Center',
    address: '120 Community Center St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: 'Free',
    attendees: 40,
    maxAttendees: 70,
    organizer: 'Social Network',
    tags: ["meetups","afternoon","today"],
    website: 'https://example.com/social-meetups-afternoon-today-20'
  },
  {
    id: 'social-meetups-afternoon-tomorrow-21',
    name: 'Tomorrow Afternoon Meetups Meetup',
    description: 'Join us for an amazing afternoon meetup focused on meetups. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Social Club',
    address: '121 Social Club St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$10',
    attendees: 41,
    maxAttendees: 71,
    organizer: 'Social Network',
    tags: ["meetups","afternoon","tomorrow"],
    website: 'https://example.com/social-meetups-afternoon-tomorrow-21'
  },
  {
    id: 'social-meetups-afternoon-this week-22',
    name: 'This Week Afternoon Meetups Meetup',
    description: 'Join us for an amazing afternoon meetup focused on meetups. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Restaurant',
    address: '122 Restaurant St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$15',
    attendees: 42,
    maxAttendees: 72,
    organizer: 'Social Network',
    tags: ["meetups","afternoon","this week"],
    website: 'https://example.com/social-meetups-afternoon-this week-22'
  },
  {
    id: 'social-meetups-afternoon-weekend-23',
    name: 'Weekend Afternoon Meetups Meetup',
    description: 'Join us for an amazing afternoon meetup focused on meetups. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Park',
    address: '123 Park St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$20',
    attendees: 43,
    maxAttendees: 73,
    organizer: 'Social Network',
    tags: ["meetups","afternoon","weekend"],
    website: 'https://example.com/social-meetups-afternoon-weekend-23'
  },
  {
    id: 'social-meetups-evening-today-24',
    name: 'Today Evening Meetups Meetup',
    description: 'Join us for an amazing evening meetup focused on meetups. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Event Space',
    address: '124 Event Space St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$25',
    attendees: 44,
    maxAttendees: 74,
    organizer: 'Social Network',
    tags: ["meetups","evening","today"],
    website: 'https://example.com/social-meetups-evening-today-24'
  },
  {
    id: 'social-meetups-evening-tomorrow-25',
    name: 'Tomorrow Evening Meetups Meetup',
    description: 'Join us for an amazing evening meetup focused on meetups. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Community Center',
    address: '125 Community Center St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$30',
    attendees: 45,
    maxAttendees: 75,
    organizer: 'Social Network',
    tags: ["meetups","evening","tomorrow"],
    website: 'https://example.com/social-meetups-evening-tomorrow-25'
  },
  {
    id: 'social-meetups-evening-this week-26',
    name: 'This Week Evening Meetups Meetup',
    description: 'Join us for an amazing evening meetup focused on meetups. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Social Club',
    address: '126 Social Club St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$35',
    attendees: 46,
    maxAttendees: 76,
    organizer: 'Social Network',
    tags: ["meetups","evening","this week"],
    website: 'https://example.com/social-meetups-evening-this week-26'
  },
  {
    id: 'social-meetups-evening-weekend-27',
    name: 'Weekend Evening Meetups Meetup',
    description: 'Join us for an amazing evening meetup focused on meetups. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Restaurant',
    address: '127 Restaurant St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$50',
    attendees: 47,
    maxAttendees: 77,
    organizer: 'Social Network',
    tags: ["meetups","evening","weekend"],
    website: 'https://example.com/social-meetups-evening-weekend-27'
  },
  {
    id: 'social-meetups-night-today-28',
    name: 'Today Night Meetups Meetup',
    description: 'Join us for an amazing night meetup focused on meetups. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Park',
    address: '128 Park St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$75',
    attendees: 48,
    maxAttendees: 78,
    organizer: 'Social Network',
    tags: ["meetups","night","today"],
    website: 'https://example.com/social-meetups-night-today-28'
  },
  {
    id: 'social-meetups-night-tomorrow-29',
    name: 'Tomorrow Night Meetups Meetup',
    description: 'Join us for an amazing night meetup focused on meetups. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Event Space',
    address: '129 Event Space St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$100',
    attendees: 49,
    maxAttendees: 79,
    organizer: 'Social Network',
    tags: ["meetups","night","tomorrow"],
    website: 'https://example.com/social-meetups-night-tomorrow-29'
  },
  {
    id: 'social-meetups-night-this week-30',
    name: 'This Week Night Meetups Meetup',
    description: 'Join us for an amazing night meetup focused on meetups. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Community Center',
    address: '130 Community Center St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: 'Free',
    attendees: 50,
    maxAttendees: 80,
    organizer: 'Social Network',
    tags: ["meetups","night","this week"],
    website: 'https://example.com/social-meetups-night-this week-30'
  },
  {
    id: 'social-meetups-night-weekend-31',
    name: 'Weekend Night Meetups Meetup',
    description: 'Join us for an amazing night meetup focused on meetups. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Meetups',
    venue: 'Social Club',
    address: '131 Social Club St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$10',
    attendees: 51,
    maxAttendees: 81,
    organizer: 'Social Network',
    tags: ["meetups","night","weekend"],
    website: 'https://example.com/social-meetups-night-weekend-31'
  },
  {
    id: 'social-dining-morning-today-32',
    name: 'Today Morning Dining Dinner',
    description: 'Join us for an amazing morning dinner focused on dining. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Restaurant',
    address: '132 Restaurant St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$15',
    attendees: 52,
    maxAttendees: 82,
    organizer: 'Social Network',
    tags: ["dining","morning","today"],
    website: 'https://example.com/social-dining-morning-today-32'
  },
  {
    id: 'social-dining-morning-tomorrow-33',
    name: 'Tomorrow Morning Dining Dinner',
    description: 'Join us for an amazing morning dinner focused on dining. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Park',
    address: '133 Park St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$20',
    attendees: 53,
    maxAttendees: 83,
    organizer: 'Social Network',
    tags: ["dining","morning","tomorrow"],
    website: 'https://example.com/social-dining-morning-tomorrow-33'
  },
  {
    id: 'social-dining-morning-this week-34',
    name: 'This Week Morning Dining Dinner',
    description: 'Join us for an amazing morning dinner focused on dining. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Event Space',
    address: '134 Event Space St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$25',
    attendees: 54,
    maxAttendees: 84,
    organizer: 'Social Network',
    tags: ["dining","morning","this week"],
    website: 'https://example.com/social-dining-morning-this week-34'
  },
  {
    id: 'social-dining-morning-weekend-35',
    name: 'Weekend Morning Dining Dinner',
    description: 'Join us for an amazing morning dinner focused on dining. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Community Center',
    address: '135 Community Center St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$30',
    attendees: 55,
    maxAttendees: 85,
    organizer: 'Social Network',
    tags: ["dining","morning","weekend"],
    website: 'https://example.com/social-dining-morning-weekend-35'
  },
  {
    id: 'social-dining-afternoon-today-36',
    name: 'Today Afternoon Dining Dinner',
    description: 'Join us for an amazing afternoon dinner focused on dining. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Social Club',
    address: '136 Social Club St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$35',
    attendees: 56,
    maxAttendees: 86,
    organizer: 'Social Network',
    tags: ["dining","afternoon","today"],
    website: 'https://example.com/social-dining-afternoon-today-36'
  },
  {
    id: 'social-dining-afternoon-tomorrow-37',
    name: 'Tomorrow Afternoon Dining Dinner',
    description: 'Join us for an amazing afternoon dinner focused on dining. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Restaurant',
    address: '137 Restaurant St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$50',
    attendees: 57,
    maxAttendees: 87,
    organizer: 'Social Network',
    tags: ["dining","afternoon","tomorrow"],
    website: 'https://example.com/social-dining-afternoon-tomorrow-37'
  },
  {
    id: 'social-dining-afternoon-this week-38',
    name: 'This Week Afternoon Dining Dinner',
    description: 'Join us for an amazing afternoon dinner focused on dining. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Park',
    address: '138 Park St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$75',
    attendees: 58,
    maxAttendees: 88,
    organizer: 'Social Network',
    tags: ["dining","afternoon","this week"],
    website: 'https://example.com/social-dining-afternoon-this week-38'
  },
  {
    id: 'social-dining-afternoon-weekend-39',
    name: 'Weekend Afternoon Dining Dinner',
    description: 'Join us for an amazing afternoon dinner focused on dining. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Event Space',
    address: '139 Event Space St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$100',
    attendees: 59,
    maxAttendees: 89,
    organizer: 'Social Network',
    tags: ["dining","afternoon","weekend"],
    website: 'https://example.com/social-dining-afternoon-weekend-39'
  },
  {
    id: 'social-dining-evening-today-40',
    name: 'Today Evening Dining Dinner',
    description: 'Join us for an amazing evening dinner focused on dining. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Community Center',
    address: '140 Community Center St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: 'Free',
    attendees: 60,
    maxAttendees: 90,
    organizer: 'Social Network',
    tags: ["dining","evening","today"],
    website: 'https://example.com/social-dining-evening-today-40'
  },
  {
    id: 'social-dining-evening-tomorrow-41',
    name: 'Tomorrow Evening Dining Dinner',
    description: 'Join us for an amazing evening dinner focused on dining. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Social Club',
    address: '141 Social Club St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$10',
    attendees: 61,
    maxAttendees: 91,
    organizer: 'Social Network',
    tags: ["dining","evening","tomorrow"],
    website: 'https://example.com/social-dining-evening-tomorrow-41'
  },
  {
    id: 'social-dining-evening-this week-42',
    name: 'This Week Evening Dining Dinner',
    description: 'Join us for an amazing evening dinner focused on dining. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Restaurant',
    address: '142 Restaurant St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$15',
    attendees: 62,
    maxAttendees: 92,
    organizer: 'Social Network',
    tags: ["dining","evening","this week"],
    website: 'https://example.com/social-dining-evening-this week-42'
  },
  {
    id: 'social-dining-evening-weekend-43',
    name: 'Weekend Evening Dining Dinner',
    description: 'Join us for an amazing evening dinner focused on dining. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Park',
    address: '143 Park St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$20',
    attendees: 63,
    maxAttendees: 93,
    organizer: 'Social Network',
    tags: ["dining","evening","weekend"],
    website: 'https://example.com/social-dining-evening-weekend-43'
  },
  {
    id: 'social-dining-night-today-44',
    name: 'Today Night Dining Dinner',
    description: 'Join us for an amazing night dinner focused on dining. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Event Space',
    address: '144 Event Space St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$25',
    attendees: 64,
    maxAttendees: 94,
    organizer: 'Social Network',
    tags: ["dining","night","today"],
    website: 'https://example.com/social-dining-night-today-44'
  },
  {
    id: 'social-dining-night-tomorrow-45',
    name: 'Tomorrow Night Dining Dinner',
    description: 'Join us for an amazing night dinner focused on dining. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Community Center',
    address: '145 Community Center St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$30',
    attendees: 65,
    maxAttendees: 95,
    organizer: 'Social Network',
    tags: ["dining","night","tomorrow"],
    website: 'https://example.com/social-dining-night-tomorrow-45'
  },
  {
    id: 'social-dining-night-this week-46',
    name: 'This Week Night Dining Dinner',
    description: 'Join us for an amazing night dinner focused on dining. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Social Club',
    address: '146 Social Club St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$35',
    attendees: 66,
    maxAttendees: 96,
    organizer: 'Social Network',
    tags: ["dining","night","this week"],
    website: 'https://example.com/social-dining-night-this week-46'
  },
  {
    id: 'social-dining-night-weekend-47',
    name: 'Weekend Night Dining Dinner',
    description: 'Join us for an amazing night dinner focused on dining. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Dining',
    venue: 'Restaurant',
    address: '147 Restaurant St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$50',
    attendees: 67,
    maxAttendees: 97,
    organizer: 'Social Network',
    tags: ["dining","night","weekend"],
    website: 'https://example.com/social-dining-night-weekend-47'
  },
  {
    id: 'social-volunteer-morning-today-48',
    name: 'Today Morning Volunteer Volunteer Event',
    description: 'Join us for an amazing morning volunteer event focused on volunteer. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Park',
    address: '148 Park St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$75',
    attendees: 68,
    maxAttendees: 98,
    organizer: 'Social Network',
    tags: ["volunteer","morning","today"],
    website: 'https://example.com/social-volunteer-morning-today-48'
  },
  {
    id: 'social-volunteer-morning-tomorrow-49',
    name: 'Tomorrow Morning Volunteer Volunteer Event',
    description: 'Join us for an amazing morning volunteer event focused on volunteer. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Event Space',
    address: '149 Event Space St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$100',
    attendees: 69,
    maxAttendees: 99,
    organizer: 'Social Network',
    tags: ["volunteer","morning","tomorrow"],
    website: 'https://example.com/social-volunteer-morning-tomorrow-49'
  },
  {
    id: 'social-volunteer-morning-this week-50',
    name: 'This Week Morning Volunteer Volunteer Event',
    description: 'Join us for an amazing morning volunteer event focused on volunteer. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Community Center',
    address: '150 Community Center St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: 'Free',
    attendees: 70,
    maxAttendees: 100,
    organizer: 'Social Network',
    tags: ["volunteer","morning","this week"],
    website: 'https://example.com/social-volunteer-morning-this week-50'
  },
  {
    id: 'social-volunteer-morning-weekend-51',
    name: 'Weekend Morning Volunteer Volunteer Event',
    description: 'Join us for an amazing morning volunteer event focused on volunteer. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Social Club',
    address: '151 Social Club St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$10',
    attendees: 71,
    maxAttendees: 101,
    organizer: 'Social Network',
    tags: ["volunteer","morning","weekend"],
    website: 'https://example.com/social-volunteer-morning-weekend-51'
  },
  {
    id: 'social-volunteer-afternoon-today-52',
    name: 'Today Afternoon Volunteer Volunteer Event',
    description: 'Join us for an amazing afternoon volunteer event focused on volunteer. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Restaurant',
    address: '152 Restaurant St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$15',
    attendees: 72,
    maxAttendees: 102,
    organizer: 'Social Network',
    tags: ["volunteer","afternoon","today"],
    website: 'https://example.com/social-volunteer-afternoon-today-52'
  },
  {
    id: 'social-volunteer-afternoon-tomorrow-53',
    name: 'Tomorrow Afternoon Volunteer Volunteer Event',
    description: 'Join us for an amazing afternoon volunteer event focused on volunteer. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Park',
    address: '153 Park St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$20',
    attendees: 73,
    maxAttendees: 103,
    organizer: 'Social Network',
    tags: ["volunteer","afternoon","tomorrow"],
    website: 'https://example.com/social-volunteer-afternoon-tomorrow-53'
  },
  {
    id: 'social-volunteer-afternoon-this week-54',
    name: 'This Week Afternoon Volunteer Volunteer Event',
    description: 'Join us for an amazing afternoon volunteer event focused on volunteer. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Event Space',
    address: '154 Event Space St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$25',
    attendees: 74,
    maxAttendees: 104,
    organizer: 'Social Network',
    tags: ["volunteer","afternoon","this week"],
    website: 'https://example.com/social-volunteer-afternoon-this week-54'
  },
  {
    id: 'social-volunteer-afternoon-weekend-55',
    name: 'Weekend Afternoon Volunteer Volunteer Event',
    description: 'Join us for an amazing afternoon volunteer event focused on volunteer. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Community Center',
    address: '155 Community Center St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$30',
    attendees: 75,
    maxAttendees: 105,
    organizer: 'Social Network',
    tags: ["volunteer","afternoon","weekend"],
    website: 'https://example.com/social-volunteer-afternoon-weekend-55'
  },
  {
    id: 'social-volunteer-evening-today-56',
    name: 'Today Evening Volunteer Volunteer Event',
    description: 'Join us for an amazing evening volunteer event focused on volunteer. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Social Club',
    address: '156 Social Club St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$35',
    attendees: 76,
    maxAttendees: 106,
    organizer: 'Social Network',
    tags: ["volunteer","evening","today"],
    website: 'https://example.com/social-volunteer-evening-today-56'
  },
  {
    id: 'social-volunteer-evening-tomorrow-57',
    name: 'Tomorrow Evening Volunteer Volunteer Event',
    description: 'Join us for an amazing evening volunteer event focused on volunteer. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Restaurant',
    address: '157 Restaurant St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$50',
    attendees: 77,
    maxAttendees: 107,
    organizer: 'Social Network',
    tags: ["volunteer","evening","tomorrow"],
    website: 'https://example.com/social-volunteer-evening-tomorrow-57'
  },
  {
    id: 'social-volunteer-evening-this week-58',
    name: 'This Week Evening Volunteer Volunteer Event',
    description: 'Join us for an amazing evening volunteer event focused on volunteer. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Park',
    address: '158 Park St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$75',
    attendees: 78,
    maxAttendees: 108,
    organizer: 'Social Network',
    tags: ["volunteer","evening","this week"],
    website: 'https://example.com/social-volunteer-evening-this week-58'
  },
  {
    id: 'social-volunteer-evening-weekend-59',
    name: 'Weekend Evening Volunteer Volunteer Event',
    description: 'Join us for an amazing evening volunteer event focused on volunteer. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Event Space',
    address: '159 Event Space St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$100',
    attendees: 79,
    maxAttendees: 109,
    organizer: 'Social Network',
    tags: ["volunteer","evening","weekend"],
    website: 'https://example.com/social-volunteer-evening-weekend-59'
  },
  {
    id: 'social-volunteer-night-today-60',
    name: 'Today Night Volunteer Volunteer Event',
    description: 'Join us for an amazing night volunteer event focused on volunteer. Perfect for today!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Community Center',
    address: '160 Community Center St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: 'Free',
    attendees: 80,
    maxAttendees: 110,
    organizer: 'Social Network',
    tags: ["volunteer","night","today"],
    website: 'https://example.com/social-volunteer-night-today-60'
  },
  {
    id: 'social-volunteer-night-tomorrow-61',
    name: 'Tomorrow Night Volunteer Volunteer Event',
    description: 'Join us for an amazing night volunteer event focused on volunteer. Perfect for tomorrow!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Social Club',
    address: '161 Social Club St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$10',
    attendees: 81,
    maxAttendees: 111,
    organizer: 'Social Network',
    tags: ["volunteer","night","tomorrow"],
    website: 'https://example.com/social-volunteer-night-tomorrow-61'
  },
  {
    id: 'social-volunteer-night-this week-62',
    name: 'This Week Night Volunteer Volunteer Event',
    description: 'Join us for an amazing night volunteer event focused on volunteer. Perfect for this week!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Restaurant',
    address: '162 Restaurant St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$15',
    attendees: 82,
    maxAttendees: 112,
    organizer: 'Social Network',
    tags: ["volunteer","night","this week"],
    website: 'https://example.com/social-volunteer-night-this week-62'
  },
  {
    id: 'social-volunteer-night-weekend-63',
    name: 'Weekend Night Volunteer Volunteer Event',
    description: 'Join us for an amazing night volunteer event focused on volunteer. Perfect for weekend!',
    categoryPrimary: 'Social',
    categorySecondary: 'Volunteer',
    venue: 'Park',
    address: '163 Park St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$20',
    attendees: 83,
    maxAttendees: 113,
    organizer: 'Social Network',
    tags: ["volunteer","night","weekend"],
    website: 'https://example.com/social-volunteer-night-weekend-63'
  },
  {
    id: 'arts/culture-music-morning-today-64',
    name: 'Today Morning Music Concert',
    description: 'Join us for an amazing morning concert focused on music. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Cultural Center',
    address: '164 Cultural Center St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$25',
    attendees: 84,
    maxAttendees: 114,
    organizer: 'Arts/Culture Network',
    tags: ["music","morning","today"],
    website: 'https://example.com/arts/culture-music-morning-today-64'
  },
  {
    id: 'arts/culture-music-morning-tomorrow-65',
    name: 'Tomorrow Morning Music Concert',
    description: 'Join us for an amazing morning concert focused on music. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Art Gallery',
    address: '165 Art Gallery St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$30',
    attendees: 85,
    maxAttendees: 115,
    organizer: 'Arts/Culture Network',
    tags: ["music","morning","tomorrow"],
    website: 'https://example.com/arts/culture-music-morning-tomorrow-65'
  },
  {
    id: 'arts/culture-music-morning-this week-66',
    name: 'This Week Morning Music Concert',
    description: 'Join us for an amazing morning concert focused on music. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Theater',
    address: '166 Theater St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$35',
    attendees: 86,
    maxAttendees: 116,
    organizer: 'Arts/Culture Network',
    tags: ["music","morning","this week"],
    website: 'https://example.com/arts/culture-music-morning-this week-66'
  },
  {
    id: 'arts/culture-music-morning-weekend-67',
    name: 'Weekend Morning Music Concert',
    description: 'Join us for an amazing morning concert focused on music. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Concert Hall',
    address: '167 Concert Hall St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$50',
    attendees: 87,
    maxAttendees: 117,
    organizer: 'Arts/Culture Network',
    tags: ["music","morning","weekend"],
    website: 'https://example.com/arts/culture-music-morning-weekend-67'
  },
  {
    id: 'arts/culture-music-afternoon-today-68',
    name: 'Today Afternoon Music Concert',
    description: 'Join us for an amazing afternoon concert focused on music. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Museum',
    address: '168 Museum St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$75',
    attendees: 88,
    maxAttendees: 118,
    organizer: 'Arts/Culture Network',
    tags: ["music","afternoon","today"],
    website: 'https://example.com/arts/culture-music-afternoon-today-68'
  },
  {
    id: 'arts/culture-music-afternoon-tomorrow-69',
    name: 'Tomorrow Afternoon Music Concert',
    description: 'Join us for an amazing afternoon concert focused on music. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Cultural Center',
    address: '169 Cultural Center St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$100',
    attendees: 89,
    maxAttendees: 119,
    organizer: 'Arts/Culture Network',
    tags: ["music","afternoon","tomorrow"],
    website: 'https://example.com/arts/culture-music-afternoon-tomorrow-69'
  },
  {
    id: 'arts/culture-music-afternoon-this week-70',
    name: 'This Week Afternoon Music Concert',
    description: 'Join us for an amazing afternoon concert focused on music. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Art Gallery',
    address: '170 Art Gallery St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: 'Free',
    attendees: 90,
    maxAttendees: 120,
    organizer: 'Arts/Culture Network',
    tags: ["music","afternoon","this week"],
    website: 'https://example.com/arts/culture-music-afternoon-this week-70'
  },
  {
    id: 'arts/culture-music-afternoon-weekend-71',
    name: 'Weekend Afternoon Music Concert',
    description: 'Join us for an amazing afternoon concert focused on music. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Theater',
    address: '171 Theater St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$10',
    attendees: 91,
    maxAttendees: 121,
    organizer: 'Arts/Culture Network',
    tags: ["music","afternoon","weekend"],
    website: 'https://example.com/arts/culture-music-afternoon-weekend-71'
  },
  {
    id: 'arts/culture-music-evening-today-72',
    name: 'Today Evening Music Concert',
    description: 'Join us for an amazing evening concert focused on music. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Concert Hall',
    address: '172 Concert Hall St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$15',
    attendees: 92,
    maxAttendees: 122,
    organizer: 'Arts/Culture Network',
    tags: ["music","evening","today"],
    website: 'https://example.com/arts/culture-music-evening-today-72'
  },
  {
    id: 'arts/culture-music-evening-tomorrow-73',
    name: 'Tomorrow Evening Music Concert',
    description: 'Join us for an amazing evening concert focused on music. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Museum',
    address: '173 Museum St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$20',
    attendees: 93,
    maxAttendees: 123,
    organizer: 'Arts/Culture Network',
    tags: ["music","evening","tomorrow"],
    website: 'https://example.com/arts/culture-music-evening-tomorrow-73'
  },
  {
    id: 'arts/culture-music-evening-this week-74',
    name: 'This Week Evening Music Concert',
    description: 'Join us for an amazing evening concert focused on music. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Cultural Center',
    address: '174 Cultural Center St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$25',
    attendees: 94,
    maxAttendees: 124,
    organizer: 'Arts/Culture Network',
    tags: ["music","evening","this week"],
    website: 'https://example.com/arts/culture-music-evening-this week-74'
  },
  {
    id: 'arts/culture-music-evening-weekend-75',
    name: 'Weekend Evening Music Concert',
    description: 'Join us for an amazing evening concert focused on music. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Art Gallery',
    address: '175 Art Gallery St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$30',
    attendees: 95,
    maxAttendees: 125,
    organizer: 'Arts/Culture Network',
    tags: ["music","evening","weekend"],
    website: 'https://example.com/arts/culture-music-evening-weekend-75'
  },
  {
    id: 'arts/culture-music-night-today-76',
    name: 'Today Night Music Concert',
    description: 'Join us for an amazing night concert focused on music. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Theater',
    address: '176 Theater St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$35',
    attendees: 96,
    maxAttendees: 126,
    organizer: 'Arts/Culture Network',
    tags: ["music","night","today"],
    website: 'https://example.com/arts/culture-music-night-today-76'
  },
  {
    id: 'arts/culture-music-night-tomorrow-77',
    name: 'Tomorrow Night Music Concert',
    description: 'Join us for an amazing night concert focused on music. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Concert Hall',
    address: '177 Concert Hall St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$50',
    attendees: 97,
    maxAttendees: 127,
    organizer: 'Arts/Culture Network',
    tags: ["music","night","tomorrow"],
    website: 'https://example.com/arts/culture-music-night-tomorrow-77'
  },
  {
    id: 'arts/culture-music-night-this week-78',
    name: 'This Week Night Music Concert',
    description: 'Join us for an amazing night concert focused on music. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Museum',
    address: '178 Museum St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$75',
    attendees: 98,
    maxAttendees: 128,
    organizer: 'Arts/Culture Network',
    tags: ["music","night","this week"],
    website: 'https://example.com/arts/culture-music-night-this week-78'
  },
  {
    id: 'arts/culture-music-night-weekend-79',
    name: 'Weekend Night Music Concert',
    description: 'Join us for an amazing night concert focused on music. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Music',
    venue: 'Cultural Center',
    address: '179 Cultural Center St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$100',
    attendees: 99,
    maxAttendees: 129,
    organizer: 'Arts/Culture Network',
    tags: ["music","night","weekend"],
    website: 'https://example.com/arts/culture-music-night-weekend-79'
  },
  {
    id: 'arts/culture-theater-morning-today-80',
    name: 'Today Morning Theater Play',
    description: 'Join us for an amazing morning play focused on theater. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Art Gallery',
    address: '180 Art Gallery St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: 'Free',
    attendees: 20,
    maxAttendees: 130,
    organizer: 'Arts/Culture Network',
    tags: ["theater","morning","today"],
    website: 'https://example.com/arts/culture-theater-morning-today-80'
  },
  {
    id: 'arts/culture-theater-morning-tomorrow-81',
    name: 'Tomorrow Morning Theater Play',
    description: 'Join us for an amazing morning play focused on theater. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Theater',
    address: '181 Theater St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$10',
    attendees: 21,
    maxAttendees: 131,
    organizer: 'Arts/Culture Network',
    tags: ["theater","morning","tomorrow"],
    website: 'https://example.com/arts/culture-theater-morning-tomorrow-81'
  },
  {
    id: 'arts/culture-theater-morning-this week-82',
    name: 'This Week Morning Theater Play',
    description: 'Join us for an amazing morning play focused on theater. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Concert Hall',
    address: '182 Concert Hall St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$15',
    attendees: 22,
    maxAttendees: 132,
    organizer: 'Arts/Culture Network',
    tags: ["theater","morning","this week"],
    website: 'https://example.com/arts/culture-theater-morning-this week-82'
  },
  {
    id: 'arts/culture-theater-morning-weekend-83',
    name: 'Weekend Morning Theater Play',
    description: 'Join us for an amazing morning play focused on theater. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Museum',
    address: '183 Museum St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$20',
    attendees: 23,
    maxAttendees: 133,
    organizer: 'Arts/Culture Network',
    tags: ["theater","morning","weekend"],
    website: 'https://example.com/arts/culture-theater-morning-weekend-83'
  },
  {
    id: 'arts/culture-theater-afternoon-today-84',
    name: 'Today Afternoon Theater Play',
    description: 'Join us for an amazing afternoon play focused on theater. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Cultural Center',
    address: '184 Cultural Center St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$25',
    attendees: 24,
    maxAttendees: 134,
    organizer: 'Arts/Culture Network',
    tags: ["theater","afternoon","today"],
    website: 'https://example.com/arts/culture-theater-afternoon-today-84'
  },
  {
    id: 'arts/culture-theater-afternoon-tomorrow-85',
    name: 'Tomorrow Afternoon Theater Play',
    description: 'Join us for an amazing afternoon play focused on theater. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Art Gallery',
    address: '185 Art Gallery St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$30',
    attendees: 25,
    maxAttendees: 135,
    organizer: 'Arts/Culture Network',
    tags: ["theater","afternoon","tomorrow"],
    website: 'https://example.com/arts/culture-theater-afternoon-tomorrow-85'
  },
  {
    id: 'arts/culture-theater-afternoon-this week-86',
    name: 'This Week Afternoon Theater Play',
    description: 'Join us for an amazing afternoon play focused on theater. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Theater',
    address: '186 Theater St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$35',
    attendees: 26,
    maxAttendees: 136,
    organizer: 'Arts/Culture Network',
    tags: ["theater","afternoon","this week"],
    website: 'https://example.com/arts/culture-theater-afternoon-this week-86'
  },
  {
    id: 'arts/culture-theater-afternoon-weekend-87',
    name: 'Weekend Afternoon Theater Play',
    description: 'Join us for an amazing afternoon play focused on theater. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Concert Hall',
    address: '187 Concert Hall St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$50',
    attendees: 27,
    maxAttendees: 137,
    organizer: 'Arts/Culture Network',
    tags: ["theater","afternoon","weekend"],
    website: 'https://example.com/arts/culture-theater-afternoon-weekend-87'
  },
  {
    id: 'arts/culture-theater-evening-today-88',
    name: 'Today Evening Theater Play',
    description: 'Join us for an amazing evening play focused on theater. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Museum',
    address: '188 Museum St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$75',
    attendees: 28,
    maxAttendees: 138,
    organizer: 'Arts/Culture Network',
    tags: ["theater","evening","today"],
    website: 'https://example.com/arts/culture-theater-evening-today-88'
  },
  {
    id: 'arts/culture-theater-evening-tomorrow-89',
    name: 'Tomorrow Evening Theater Play',
    description: 'Join us for an amazing evening play focused on theater. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Cultural Center',
    address: '189 Cultural Center St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$100',
    attendees: 29,
    maxAttendees: 139,
    organizer: 'Arts/Culture Network',
    tags: ["theater","evening","tomorrow"],
    website: 'https://example.com/arts/culture-theater-evening-tomorrow-89'
  },
  {
    id: 'arts/culture-theater-evening-this week-90',
    name: 'This Week Evening Theater Play',
    description: 'Join us for an amazing evening play focused on theater. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Art Gallery',
    address: '190 Art Gallery St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: 'Free',
    attendees: 30,
    maxAttendees: 140,
    organizer: 'Arts/Culture Network',
    tags: ["theater","evening","this week"],
    website: 'https://example.com/arts/culture-theater-evening-this week-90'
  },
  {
    id: 'arts/culture-theater-evening-weekend-91',
    name: 'Weekend Evening Theater Play',
    description: 'Join us for an amazing evening play focused on theater. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Theater',
    address: '191 Theater St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$10',
    attendees: 31,
    maxAttendees: 141,
    organizer: 'Arts/Culture Network',
    tags: ["theater","evening","weekend"],
    website: 'https://example.com/arts/culture-theater-evening-weekend-91'
  },
  {
    id: 'arts/culture-theater-night-today-92',
    name: 'Today Night Theater Play',
    description: 'Join us for an amazing night play focused on theater. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Concert Hall',
    address: '192 Concert Hall St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$15',
    attendees: 32,
    maxAttendees: 142,
    organizer: 'Arts/Culture Network',
    tags: ["theater","night","today"],
    website: 'https://example.com/arts/culture-theater-night-today-92'
  },
  {
    id: 'arts/culture-theater-night-tomorrow-93',
    name: 'Tomorrow Night Theater Play',
    description: 'Join us for an amazing night play focused on theater. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Museum',
    address: '193 Museum St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$20',
    attendees: 33,
    maxAttendees: 143,
    organizer: 'Arts/Culture Network',
    tags: ["theater","night","tomorrow"],
    website: 'https://example.com/arts/culture-theater-night-tomorrow-93'
  },
  {
    id: 'arts/culture-theater-night-this week-94',
    name: 'This Week Night Theater Play',
    description: 'Join us for an amazing night play focused on theater. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Cultural Center',
    address: '194 Cultural Center St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$25',
    attendees: 34,
    maxAttendees: 144,
    organizer: 'Arts/Culture Network',
    tags: ["theater","night","this week"],
    website: 'https://example.com/arts/culture-theater-night-this week-94'
  },
  {
    id: 'arts/culture-theater-night-weekend-95',
    name: 'Weekend Night Theater Play',
    description: 'Join us for an amazing night play focused on theater. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Theater',
    venue: 'Art Gallery',
    address: '195 Art Gallery St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$30',
    attendees: 35,
    maxAttendees: 145,
    organizer: 'Arts/Culture Network',
    tags: ["theater","night","weekend"],
    website: 'https://example.com/arts/culture-theater-night-weekend-95'
  },
  {
    id: 'arts/culture-galleries-morning-today-96',
    name: 'Today Morning Galleries Exhibition',
    description: 'Join us for an amazing morning exhibition focused on galleries. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Theater',
    address: '196 Theater St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$35',
    attendees: 36,
    maxAttendees: 146,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","morning","today"],
    website: 'https://example.com/arts/culture-galleries-morning-today-96'
  },
  {
    id: 'arts/culture-galleries-morning-tomorrow-97',
    name: 'Tomorrow Morning Galleries Exhibition',
    description: 'Join us for an amazing morning exhibition focused on galleries. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Concert Hall',
    address: '197 Concert Hall St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$50',
    attendees: 37,
    maxAttendees: 147,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","morning","tomorrow"],
    website: 'https://example.com/arts/culture-galleries-morning-tomorrow-97'
  },
  {
    id: 'arts/culture-galleries-morning-this week-98',
    name: 'This Week Morning Galleries Exhibition',
    description: 'Join us for an amazing morning exhibition focused on galleries. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Museum',
    address: '198 Museum St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$75',
    attendees: 38,
    maxAttendees: 148,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","morning","this week"],
    website: 'https://example.com/arts/culture-galleries-morning-this week-98'
  },
  {
    id: 'arts/culture-galleries-morning-weekend-99',
    name: 'Weekend Morning Galleries Exhibition',
    description: 'Join us for an amazing morning exhibition focused on galleries. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Cultural Center',
    address: '199 Cultural Center St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$100',
    attendees: 39,
    maxAttendees: 149,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","morning","weekend"],
    website: 'https://example.com/arts/culture-galleries-morning-weekend-99'
  },
  {
    id: 'arts/culture-galleries-afternoon-today-100',
    name: 'Today Afternoon Galleries Exhibition',
    description: 'Join us for an amazing afternoon exhibition focused on galleries. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Art Gallery',
    address: '200 Art Gallery St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: 'Free',
    attendees: 40,
    maxAttendees: 150,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","afternoon","today"],
    website: 'https://example.com/arts/culture-galleries-afternoon-today-100'
  },
  {
    id: 'arts/culture-galleries-afternoon-tomorrow-101',
    name: 'Tomorrow Afternoon Galleries Exhibition',
    description: 'Join us for an amazing afternoon exhibition focused on galleries. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Theater',
    address: '201 Theater St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$10',
    attendees: 41,
    maxAttendees: 151,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","afternoon","tomorrow"],
    website: 'https://example.com/arts/culture-galleries-afternoon-tomorrow-101'
  },
  {
    id: 'arts/culture-galleries-afternoon-this week-102',
    name: 'This Week Afternoon Galleries Exhibition',
    description: 'Join us for an amazing afternoon exhibition focused on galleries. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Concert Hall',
    address: '202 Concert Hall St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$15',
    attendees: 42,
    maxAttendees: 152,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","afternoon","this week"],
    website: 'https://example.com/arts/culture-galleries-afternoon-this week-102'
  },
  {
    id: 'arts/culture-galleries-afternoon-weekend-103',
    name: 'Weekend Afternoon Galleries Exhibition',
    description: 'Join us for an amazing afternoon exhibition focused on galleries. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Museum',
    address: '203 Museum St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$20',
    attendees: 43,
    maxAttendees: 153,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","afternoon","weekend"],
    website: 'https://example.com/arts/culture-galleries-afternoon-weekend-103'
  },
  {
    id: 'arts/culture-galleries-evening-today-104',
    name: 'Today Evening Galleries Exhibition',
    description: 'Join us for an amazing evening exhibition focused on galleries. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Cultural Center',
    address: '204 Cultural Center St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$25',
    attendees: 44,
    maxAttendees: 154,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","evening","today"],
    website: 'https://example.com/arts/culture-galleries-evening-today-104'
  },
  {
    id: 'arts/culture-galleries-evening-tomorrow-105',
    name: 'Tomorrow Evening Galleries Exhibition',
    description: 'Join us for an amazing evening exhibition focused on galleries. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Art Gallery',
    address: '205 Art Gallery St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$30',
    attendees: 45,
    maxAttendees: 155,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","evening","tomorrow"],
    website: 'https://example.com/arts/culture-galleries-evening-tomorrow-105'
  },
  {
    id: 'arts/culture-galleries-evening-this week-106',
    name: 'This Week Evening Galleries Exhibition',
    description: 'Join us for an amazing evening exhibition focused on galleries. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Theater',
    address: '206 Theater St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$35',
    attendees: 46,
    maxAttendees: 156,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","evening","this week"],
    website: 'https://example.com/arts/culture-galleries-evening-this week-106'
  },
  {
    id: 'arts/culture-galleries-evening-weekend-107',
    name: 'Weekend Evening Galleries Exhibition',
    description: 'Join us for an amazing evening exhibition focused on galleries. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Concert Hall',
    address: '207 Concert Hall St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$50',
    attendees: 47,
    maxAttendees: 157,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","evening","weekend"],
    website: 'https://example.com/arts/culture-galleries-evening-weekend-107'
  },
  {
    id: 'arts/culture-galleries-night-today-108',
    name: 'Today Night Galleries Exhibition',
    description: 'Join us for an amazing night exhibition focused on galleries. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Museum',
    address: '208 Museum St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$75',
    attendees: 48,
    maxAttendees: 158,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","night","today"],
    website: 'https://example.com/arts/culture-galleries-night-today-108'
  },
  {
    id: 'arts/culture-galleries-night-tomorrow-109',
    name: 'Tomorrow Night Galleries Exhibition',
    description: 'Join us for an amazing night exhibition focused on galleries. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Cultural Center',
    address: '209 Cultural Center St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$100',
    attendees: 49,
    maxAttendees: 159,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","night","tomorrow"],
    website: 'https://example.com/arts/culture-galleries-night-tomorrow-109'
  },
  {
    id: 'arts/culture-galleries-night-this week-110',
    name: 'This Week Night Galleries Exhibition',
    description: 'Join us for an amazing night exhibition focused on galleries. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Art Gallery',
    address: '210 Art Gallery St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: 'Free',
    attendees: 50,
    maxAttendees: 160,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","night","this week"],
    website: 'https://example.com/arts/culture-galleries-night-this week-110'
  },
  {
    id: 'arts/culture-galleries-night-weekend-111',
    name: 'Weekend Night Galleries Exhibition',
    description: 'Join us for an amazing night exhibition focused on galleries. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Galleries',
    venue: 'Theater',
    address: '211 Theater St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$10',
    attendees: 51,
    maxAttendees: 161,
    organizer: 'Arts/Culture Network',
    tags: ["galleries","night","weekend"],
    website: 'https://example.com/arts/culture-galleries-night-weekend-111'
  },
  {
    id: 'arts/culture-film-morning-today-112',
    name: 'Today Morning Film Film Screening',
    description: 'Join us for an amazing morning film screening focused on film. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Concert Hall',
    address: '212 Concert Hall St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$15',
    attendees: 52,
    maxAttendees: 162,
    organizer: 'Arts/Culture Network',
    tags: ["film","morning","today"],
    website: 'https://example.com/arts/culture-film-morning-today-112'
  },
  {
    id: 'arts/culture-film-morning-tomorrow-113',
    name: 'Tomorrow Morning Film Film Screening',
    description: 'Join us for an amazing morning film screening focused on film. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Museum',
    address: '213 Museum St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$20',
    attendees: 53,
    maxAttendees: 163,
    organizer: 'Arts/Culture Network',
    tags: ["film","morning","tomorrow"],
    website: 'https://example.com/arts/culture-film-morning-tomorrow-113'
  },
  {
    id: 'arts/culture-film-morning-this week-114',
    name: 'This Week Morning Film Film Screening',
    description: 'Join us for an amazing morning film screening focused on film. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Cultural Center',
    address: '214 Cultural Center St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$25',
    attendees: 54,
    maxAttendees: 164,
    organizer: 'Arts/Culture Network',
    tags: ["film","morning","this week"],
    website: 'https://example.com/arts/culture-film-morning-this week-114'
  },
  {
    id: 'arts/culture-film-morning-weekend-115',
    name: 'Weekend Morning Film Film Screening',
    description: 'Join us for an amazing morning film screening focused on film. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Art Gallery',
    address: '215 Art Gallery St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$30',
    attendees: 55,
    maxAttendees: 165,
    organizer: 'Arts/Culture Network',
    tags: ["film","morning","weekend"],
    website: 'https://example.com/arts/culture-film-morning-weekend-115'
  },
  {
    id: 'arts/culture-film-afternoon-today-116',
    name: 'Today Afternoon Film Film Screening',
    description: 'Join us for an amazing afternoon film screening focused on film. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Theater',
    address: '216 Theater St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$35',
    attendees: 56,
    maxAttendees: 166,
    organizer: 'Arts/Culture Network',
    tags: ["film","afternoon","today"],
    website: 'https://example.com/arts/culture-film-afternoon-today-116'
  },
  {
    id: 'arts/culture-film-afternoon-tomorrow-117',
    name: 'Tomorrow Afternoon Film Film Screening',
    description: 'Join us for an amazing afternoon film screening focused on film. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Concert Hall',
    address: '217 Concert Hall St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$50',
    attendees: 57,
    maxAttendees: 167,
    organizer: 'Arts/Culture Network',
    tags: ["film","afternoon","tomorrow"],
    website: 'https://example.com/arts/culture-film-afternoon-tomorrow-117'
  },
  {
    id: 'arts/culture-film-afternoon-this week-118',
    name: 'This Week Afternoon Film Film Screening',
    description: 'Join us for an amazing afternoon film screening focused on film. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Museum',
    address: '218 Museum St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$75',
    attendees: 58,
    maxAttendees: 168,
    organizer: 'Arts/Culture Network',
    tags: ["film","afternoon","this week"],
    website: 'https://example.com/arts/culture-film-afternoon-this week-118'
  },
  {
    id: 'arts/culture-film-afternoon-weekend-119',
    name: 'Weekend Afternoon Film Film Screening',
    description: 'Join us for an amazing afternoon film screening focused on film. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Cultural Center',
    address: '219 Cultural Center St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$100',
    attendees: 59,
    maxAttendees: 169,
    organizer: 'Arts/Culture Network',
    tags: ["film","afternoon","weekend"],
    website: 'https://example.com/arts/culture-film-afternoon-weekend-119'
  },
  {
    id: 'arts/culture-film-evening-today-120',
    name: 'Today Evening Film Film Screening',
    description: 'Join us for an amazing evening film screening focused on film. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Art Gallery',
    address: '220 Art Gallery St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: 'Free',
    attendees: 60,
    maxAttendees: 170,
    organizer: 'Arts/Culture Network',
    tags: ["film","evening","today"],
    website: 'https://example.com/arts/culture-film-evening-today-120'
  },
  {
    id: 'arts/culture-film-evening-tomorrow-121',
    name: 'Tomorrow Evening Film Film Screening',
    description: 'Join us for an amazing evening film screening focused on film. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Theater',
    address: '221 Theater St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$10',
    attendees: 61,
    maxAttendees: 171,
    organizer: 'Arts/Culture Network',
    tags: ["film","evening","tomorrow"],
    website: 'https://example.com/arts/culture-film-evening-tomorrow-121'
  },
  {
    id: 'arts/culture-film-evening-this week-122',
    name: 'This Week Evening Film Film Screening',
    description: 'Join us for an amazing evening film screening focused on film. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Concert Hall',
    address: '222 Concert Hall St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$15',
    attendees: 62,
    maxAttendees: 172,
    organizer: 'Arts/Culture Network',
    tags: ["film","evening","this week"],
    website: 'https://example.com/arts/culture-film-evening-this week-122'
  },
  {
    id: 'arts/culture-film-evening-weekend-123',
    name: 'Weekend Evening Film Film Screening',
    description: 'Join us for an amazing evening film screening focused on film. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Museum',
    address: '223 Museum St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$20',
    attendees: 63,
    maxAttendees: 173,
    organizer: 'Arts/Culture Network',
    tags: ["film","evening","weekend"],
    website: 'https://example.com/arts/culture-film-evening-weekend-123'
  },
  {
    id: 'arts/culture-film-night-today-124',
    name: 'Today Night Film Film Screening',
    description: 'Join us for an amazing night film screening focused on film. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Cultural Center',
    address: '224 Cultural Center St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$25',
    attendees: 64,
    maxAttendees: 174,
    organizer: 'Arts/Culture Network',
    tags: ["film","night","today"],
    website: 'https://example.com/arts/culture-film-night-today-124'
  },
  {
    id: 'arts/culture-film-night-tomorrow-125',
    name: 'Tomorrow Night Film Film Screening',
    description: 'Join us for an amazing night film screening focused on film. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Art Gallery',
    address: '225 Art Gallery St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$30',
    attendees: 65,
    maxAttendees: 175,
    organizer: 'Arts/Culture Network',
    tags: ["film","night","tomorrow"],
    website: 'https://example.com/arts/culture-film-night-tomorrow-125'
  },
  {
    id: 'arts/culture-film-night-this week-126',
    name: 'This Week Night Film Film Screening',
    description: 'Join us for an amazing night film screening focused on film. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Theater',
    address: '226 Theater St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$35',
    attendees: 66,
    maxAttendees: 176,
    organizer: 'Arts/Culture Network',
    tags: ["film","night","this week"],
    website: 'https://example.com/arts/culture-film-night-this week-126'
  },
  {
    id: 'arts/culture-film-night-weekend-127',
    name: 'Weekend Night Film Film Screening',
    description: 'Join us for an amazing night film screening focused on film. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Film',
    venue: 'Concert Hall',
    address: '227 Concert Hall St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$50',
    attendees: 67,
    maxAttendees: 177,
    organizer: 'Arts/Culture Network',
    tags: ["film","night","weekend"],
    website: 'https://example.com/arts/culture-film-night-weekend-127'
  },
  {
    id: 'arts/culture-festivals-morning-today-128',
    name: 'Today Morning Festivals Festival',
    description: 'Join us for an amazing morning festival focused on festivals. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Museum',
    address: '228 Museum St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$75',
    attendees: 68,
    maxAttendees: 178,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","morning","today"],
    website: 'https://example.com/arts/culture-festivals-morning-today-128'
  },
  {
    id: 'arts/culture-festivals-morning-tomorrow-129',
    name: 'Tomorrow Morning Festivals Festival',
    description: 'Join us for an amazing morning festival focused on festivals. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Cultural Center',
    address: '229 Cultural Center St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$100',
    attendees: 69,
    maxAttendees: 179,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","morning","tomorrow"],
    website: 'https://example.com/arts/culture-festivals-morning-tomorrow-129'
  },
  {
    id: 'arts/culture-festivals-morning-this week-130',
    name: 'This Week Morning Festivals Festival',
    description: 'Join us for an amazing morning festival focused on festivals. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Art Gallery',
    address: '230 Art Gallery St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: 'Free',
    attendees: 70,
    maxAttendees: 180,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","morning","this week"],
    website: 'https://example.com/arts/culture-festivals-morning-this week-130'
  },
  {
    id: 'arts/culture-festivals-morning-weekend-131',
    name: 'Weekend Morning Festivals Festival',
    description: 'Join us for an amazing morning festival focused on festivals. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Theater',
    address: '231 Theater St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$10',
    attendees: 71,
    maxAttendees: 181,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","morning","weekend"],
    website: 'https://example.com/arts/culture-festivals-morning-weekend-131'
  },
  {
    id: 'arts/culture-festivals-afternoon-today-132',
    name: 'Today Afternoon Festivals Festival',
    description: 'Join us for an amazing afternoon festival focused on festivals. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Concert Hall',
    address: '232 Concert Hall St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$15',
    attendees: 72,
    maxAttendees: 182,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","afternoon","today"],
    website: 'https://example.com/arts/culture-festivals-afternoon-today-132'
  },
  {
    id: 'arts/culture-festivals-afternoon-tomorrow-133',
    name: 'Tomorrow Afternoon Festivals Festival',
    description: 'Join us for an amazing afternoon festival focused on festivals. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Museum',
    address: '233 Museum St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$20',
    attendees: 73,
    maxAttendees: 183,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","afternoon","tomorrow"],
    website: 'https://example.com/arts/culture-festivals-afternoon-tomorrow-133'
  },
  {
    id: 'arts/culture-festivals-afternoon-this week-134',
    name: 'This Week Afternoon Festivals Festival',
    description: 'Join us for an amazing afternoon festival focused on festivals. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Cultural Center',
    address: '234 Cultural Center St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$25',
    attendees: 74,
    maxAttendees: 184,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","afternoon","this week"],
    website: 'https://example.com/arts/culture-festivals-afternoon-this week-134'
  },
  {
    id: 'arts/culture-festivals-afternoon-weekend-135',
    name: 'Weekend Afternoon Festivals Festival',
    description: 'Join us for an amazing afternoon festival focused on festivals. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Art Gallery',
    address: '235 Art Gallery St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$30',
    attendees: 75,
    maxAttendees: 185,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","afternoon","weekend"],
    website: 'https://example.com/arts/culture-festivals-afternoon-weekend-135'
  },
  {
    id: 'arts/culture-festivals-evening-today-136',
    name: 'Today Evening Festivals Festival',
    description: 'Join us for an amazing evening festival focused on festivals. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Theater',
    address: '236 Theater St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$35',
    attendees: 76,
    maxAttendees: 186,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","evening","today"],
    website: 'https://example.com/arts/culture-festivals-evening-today-136'
  },
  {
    id: 'arts/culture-festivals-evening-tomorrow-137',
    name: 'Tomorrow Evening Festivals Festival',
    description: 'Join us for an amazing evening festival focused on festivals. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Concert Hall',
    address: '237 Concert Hall St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$50',
    attendees: 77,
    maxAttendees: 187,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","evening","tomorrow"],
    website: 'https://example.com/arts/culture-festivals-evening-tomorrow-137'
  },
  {
    id: 'arts/culture-festivals-evening-this week-138',
    name: 'This Week Evening Festivals Festival',
    description: 'Join us for an amazing evening festival focused on festivals. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Museum',
    address: '238 Museum St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$75',
    attendees: 78,
    maxAttendees: 188,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","evening","this week"],
    website: 'https://example.com/arts/culture-festivals-evening-this week-138'
  },
  {
    id: 'arts/culture-festivals-evening-weekend-139',
    name: 'Weekend Evening Festivals Festival',
    description: 'Join us for an amazing evening festival focused on festivals. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Cultural Center',
    address: '239 Cultural Center St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$100',
    attendees: 79,
    maxAttendees: 189,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","evening","weekend"],
    website: 'https://example.com/arts/culture-festivals-evening-weekend-139'
  },
  {
    id: 'arts/culture-festivals-night-today-140',
    name: 'Today Night Festivals Festival',
    description: 'Join us for an amazing night festival focused on festivals. Perfect for today!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Art Gallery',
    address: '240 Art Gallery St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: 'Free',
    attendees: 80,
    maxAttendees: 190,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","night","today"],
    website: 'https://example.com/arts/culture-festivals-night-today-140'
  },
  {
    id: 'arts/culture-festivals-night-tomorrow-141',
    name: 'Tomorrow Night Festivals Festival',
    description: 'Join us for an amazing night festival focused on festivals. Perfect for tomorrow!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Theater',
    address: '241 Theater St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$10',
    attendees: 81,
    maxAttendees: 191,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","night","tomorrow"],
    website: 'https://example.com/arts/culture-festivals-night-tomorrow-141'
  },
  {
    id: 'arts/culture-festivals-night-this week-142',
    name: 'This Week Night Festivals Festival',
    description: 'Join us for an amazing night festival focused on festivals. Perfect for this week!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Concert Hall',
    address: '242 Concert Hall St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$15',
    attendees: 82,
    maxAttendees: 192,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","night","this week"],
    website: 'https://example.com/arts/culture-festivals-night-this week-142'
  },
  {
    id: 'arts/culture-festivals-night-weekend-143',
    name: 'Weekend Night Festivals Festival',
    description: 'Join us for an amazing night festival focused on festivals. Perfect for weekend!',
    categoryPrimary: 'Arts/Culture',
    categorySecondary: 'Festivals',
    venue: 'Museum',
    address: '243 Museum St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$20',
    attendees: 83,
    maxAttendees: 193,
    organizer: 'Arts/Culture Network',
    tags: ["festivals","night","weekend"],
    website: 'https://example.com/arts/culture-festivals-night-weekend-143'
  },
  {
    id: 'wellness-fitness-morning-today-144',
    name: 'Today Morning Fitness Workout',
    description: 'Join us for an amazing morning workout focused on fitness. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Outdoor Park',
    address: '244 Outdoor Park St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$25',
    attendees: 84,
    maxAttendees: 194,
    organizer: 'Wellness Network',
    tags: ["fitness","morning","today"],
    website: 'https://example.com/wellness-fitness-morning-today-144'
  },
  {
    id: 'wellness-fitness-morning-tomorrow-145',
    name: 'Tomorrow Morning Fitness Workout',
    description: 'Join us for an amazing morning workout focused on fitness. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Gym',
    address: '245 Gym St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$30',
    attendees: 85,
    maxAttendees: 195,
    organizer: 'Wellness Network',
    tags: ["fitness","morning","tomorrow"],
    website: 'https://example.com/wellness-fitness-morning-tomorrow-145'
  },
  {
    id: 'wellness-fitness-morning-this week-146',
    name: 'This Week Morning Fitness Workout',
    description: 'Join us for an amazing morning workout focused on fitness. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Yoga Studio',
    address: '246 Yoga Studio St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$35',
    attendees: 86,
    maxAttendees: 196,
    organizer: 'Wellness Network',
    tags: ["fitness","morning","this week"],
    website: 'https://example.com/wellness-fitness-morning-this week-146'
  },
  {
    id: 'wellness-fitness-morning-weekend-147',
    name: 'Weekend Morning Fitness Workout',
    description: 'Join us for an amazing morning workout focused on fitness. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Sports Center',
    address: '247 Sports Center St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$50',
    attendees: 87,
    maxAttendees: 197,
    organizer: 'Wellness Network',
    tags: ["fitness","morning","weekend"],
    website: 'https://example.com/wellness-fitness-morning-weekend-147'
  },
  {
    id: 'wellness-fitness-afternoon-today-148',
    name: 'Today Afternoon Fitness Workout',
    description: 'Join us for an amazing afternoon workout focused on fitness. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Wellness Center',
    address: '248 Wellness Center St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$75',
    attendees: 88,
    maxAttendees: 198,
    organizer: 'Wellness Network',
    tags: ["fitness","afternoon","today"],
    website: 'https://example.com/wellness-fitness-afternoon-today-148'
  },
  {
    id: 'wellness-fitness-afternoon-tomorrow-149',
    name: 'Tomorrow Afternoon Fitness Workout',
    description: 'Join us for an amazing afternoon workout focused on fitness. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Outdoor Park',
    address: '249 Outdoor Park St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$100',
    attendees: 89,
    maxAttendees: 199,
    organizer: 'Wellness Network',
    tags: ["fitness","afternoon","tomorrow"],
    website: 'https://example.com/wellness-fitness-afternoon-tomorrow-149'
  },
  {
    id: 'wellness-fitness-afternoon-this week-150',
    name: 'This Week Afternoon Fitness Workout',
    description: 'Join us for an amazing afternoon workout focused on fitness. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Gym',
    address: '250 Gym St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: 'Free',
    attendees: 90,
    maxAttendees: 50,
    organizer: 'Wellness Network',
    tags: ["fitness","afternoon","this week"],
    website: 'https://example.com/wellness-fitness-afternoon-this week-150'
  },
  {
    id: 'wellness-fitness-afternoon-weekend-151',
    name: 'Weekend Afternoon Fitness Workout',
    description: 'Join us for an amazing afternoon workout focused on fitness. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Yoga Studio',
    address: '251 Yoga Studio St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$10',
    attendees: 91,
    maxAttendees: 51,
    organizer: 'Wellness Network',
    tags: ["fitness","afternoon","weekend"],
    website: 'https://example.com/wellness-fitness-afternoon-weekend-151'
  },
  {
    id: 'wellness-fitness-evening-today-152',
    name: 'Today Evening Fitness Workout',
    description: 'Join us for an amazing evening workout focused on fitness. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Sports Center',
    address: '252 Sports Center St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$15',
    attendees: 92,
    maxAttendees: 52,
    organizer: 'Wellness Network',
    tags: ["fitness","evening","today"],
    website: 'https://example.com/wellness-fitness-evening-today-152'
  },
  {
    id: 'wellness-fitness-evening-tomorrow-153',
    name: 'Tomorrow Evening Fitness Workout',
    description: 'Join us for an amazing evening workout focused on fitness. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Wellness Center',
    address: '253 Wellness Center St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$20',
    attendees: 93,
    maxAttendees: 53,
    organizer: 'Wellness Network',
    tags: ["fitness","evening","tomorrow"],
    website: 'https://example.com/wellness-fitness-evening-tomorrow-153'
  },
  {
    id: 'wellness-fitness-evening-this week-154',
    name: 'This Week Evening Fitness Workout',
    description: 'Join us for an amazing evening workout focused on fitness. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Outdoor Park',
    address: '254 Outdoor Park St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$25',
    attendees: 94,
    maxAttendees: 54,
    organizer: 'Wellness Network',
    tags: ["fitness","evening","this week"],
    website: 'https://example.com/wellness-fitness-evening-this week-154'
  },
  {
    id: 'wellness-fitness-evening-weekend-155',
    name: 'Weekend Evening Fitness Workout',
    description: 'Join us for an amazing evening workout focused on fitness. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Gym',
    address: '255 Gym St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$30',
    attendees: 95,
    maxAttendees: 55,
    organizer: 'Wellness Network',
    tags: ["fitness","evening","weekend"],
    website: 'https://example.com/wellness-fitness-evening-weekend-155'
  },
  {
    id: 'wellness-fitness-night-today-156',
    name: 'Today Night Fitness Workout',
    description: 'Join us for an amazing night workout focused on fitness. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Yoga Studio',
    address: '256 Yoga Studio St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$35',
    attendees: 96,
    maxAttendees: 56,
    organizer: 'Wellness Network',
    tags: ["fitness","night","today"],
    website: 'https://example.com/wellness-fitness-night-today-156'
  },
  {
    id: 'wellness-fitness-night-tomorrow-157',
    name: 'Tomorrow Night Fitness Workout',
    description: 'Join us for an amazing night workout focused on fitness. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Sports Center',
    address: '257 Sports Center St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$50',
    attendees: 97,
    maxAttendees: 57,
    organizer: 'Wellness Network',
    tags: ["fitness","night","tomorrow"],
    website: 'https://example.com/wellness-fitness-night-tomorrow-157'
  },
  {
    id: 'wellness-fitness-night-this week-158',
    name: 'This Week Night Fitness Workout',
    description: 'Join us for an amazing night workout focused on fitness. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Wellness Center',
    address: '258 Wellness Center St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$75',
    attendees: 98,
    maxAttendees: 58,
    organizer: 'Wellness Network',
    tags: ["fitness","night","this week"],
    website: 'https://example.com/wellness-fitness-night-this week-158'
  },
  {
    id: 'wellness-fitness-night-weekend-159',
    name: 'Weekend Night Fitness Workout',
    description: 'Join us for an amazing night workout focused on fitness. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Fitness',
    venue: 'Outdoor Park',
    address: '259 Outdoor Park St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$100',
    attendees: 99,
    maxAttendees: 59,
    organizer: 'Wellness Network',
    tags: ["fitness","night","weekend"],
    website: 'https://example.com/wellness-fitness-night-weekend-159'
  },
  {
    id: 'wellness-outdoor-morning-today-160',
    name: 'Today Morning Outdoor Outdoor Activity',
    description: 'Join us for an amazing morning outdoor activity focused on outdoor. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Gym',
    address: '260 Gym St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: 'Free',
    attendees: 20,
    maxAttendees: 60,
    organizer: 'Wellness Network',
    tags: ["outdoor","morning","today"],
    website: 'https://example.com/wellness-outdoor-morning-today-160'
  },
  {
    id: 'wellness-outdoor-morning-tomorrow-161',
    name: 'Tomorrow Morning Outdoor Outdoor Activity',
    description: 'Join us for an amazing morning outdoor activity focused on outdoor. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Yoga Studio',
    address: '261 Yoga Studio St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$10',
    attendees: 21,
    maxAttendees: 61,
    organizer: 'Wellness Network',
    tags: ["outdoor","morning","tomorrow"],
    website: 'https://example.com/wellness-outdoor-morning-tomorrow-161'
  },
  {
    id: 'wellness-outdoor-morning-this week-162',
    name: 'This Week Morning Outdoor Outdoor Activity',
    description: 'Join us for an amazing morning outdoor activity focused on outdoor. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Sports Center',
    address: '262 Sports Center St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$15',
    attendees: 22,
    maxAttendees: 62,
    organizer: 'Wellness Network',
    tags: ["outdoor","morning","this week"],
    website: 'https://example.com/wellness-outdoor-morning-this week-162'
  },
  {
    id: 'wellness-outdoor-morning-weekend-163',
    name: 'Weekend Morning Outdoor Outdoor Activity',
    description: 'Join us for an amazing morning outdoor activity focused on outdoor. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Wellness Center',
    address: '263 Wellness Center St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$20',
    attendees: 23,
    maxAttendees: 63,
    organizer: 'Wellness Network',
    tags: ["outdoor","morning","weekend"],
    website: 'https://example.com/wellness-outdoor-morning-weekend-163'
  },
  {
    id: 'wellness-outdoor-afternoon-today-164',
    name: 'Today Afternoon Outdoor Outdoor Activity',
    description: 'Join us for an amazing afternoon outdoor activity focused on outdoor. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Outdoor Park',
    address: '264 Outdoor Park St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$25',
    attendees: 24,
    maxAttendees: 64,
    organizer: 'Wellness Network',
    tags: ["outdoor","afternoon","today"],
    website: 'https://example.com/wellness-outdoor-afternoon-today-164'
  },
  {
    id: 'wellness-outdoor-afternoon-tomorrow-165',
    name: 'Tomorrow Afternoon Outdoor Outdoor Activity',
    description: 'Join us for an amazing afternoon outdoor activity focused on outdoor. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Gym',
    address: '265 Gym St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$30',
    attendees: 25,
    maxAttendees: 65,
    organizer: 'Wellness Network',
    tags: ["outdoor","afternoon","tomorrow"],
    website: 'https://example.com/wellness-outdoor-afternoon-tomorrow-165'
  },
  {
    id: 'wellness-outdoor-afternoon-this week-166',
    name: 'This Week Afternoon Outdoor Outdoor Activity',
    description: 'Join us for an amazing afternoon outdoor activity focused on outdoor. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Yoga Studio',
    address: '266 Yoga Studio St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$35',
    attendees: 26,
    maxAttendees: 66,
    organizer: 'Wellness Network',
    tags: ["outdoor","afternoon","this week"],
    website: 'https://example.com/wellness-outdoor-afternoon-this week-166'
  },
  {
    id: 'wellness-outdoor-afternoon-weekend-167',
    name: 'Weekend Afternoon Outdoor Outdoor Activity',
    description: 'Join us for an amazing afternoon outdoor activity focused on outdoor. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Sports Center',
    address: '267 Sports Center St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$50',
    attendees: 27,
    maxAttendees: 67,
    organizer: 'Wellness Network',
    tags: ["outdoor","afternoon","weekend"],
    website: 'https://example.com/wellness-outdoor-afternoon-weekend-167'
  },
  {
    id: 'wellness-outdoor-evening-today-168',
    name: 'Today Evening Outdoor Outdoor Activity',
    description: 'Join us for an amazing evening outdoor activity focused on outdoor. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Wellness Center',
    address: '268 Wellness Center St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$75',
    attendees: 28,
    maxAttendees: 68,
    organizer: 'Wellness Network',
    tags: ["outdoor","evening","today"],
    website: 'https://example.com/wellness-outdoor-evening-today-168'
  },
  {
    id: 'wellness-outdoor-evening-tomorrow-169',
    name: 'Tomorrow Evening Outdoor Outdoor Activity',
    description: 'Join us for an amazing evening outdoor activity focused on outdoor. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Outdoor Park',
    address: '269 Outdoor Park St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$100',
    attendees: 29,
    maxAttendees: 69,
    organizer: 'Wellness Network',
    tags: ["outdoor","evening","tomorrow"],
    website: 'https://example.com/wellness-outdoor-evening-tomorrow-169'
  },
  {
    id: 'wellness-outdoor-evening-this week-170',
    name: 'This Week Evening Outdoor Outdoor Activity',
    description: 'Join us for an amazing evening outdoor activity focused on outdoor. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Gym',
    address: '270 Gym St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: 'Free',
    attendees: 30,
    maxAttendees: 70,
    organizer: 'Wellness Network',
    tags: ["outdoor","evening","this week"],
    website: 'https://example.com/wellness-outdoor-evening-this week-170'
  },
  {
    id: 'wellness-outdoor-evening-weekend-171',
    name: 'Weekend Evening Outdoor Outdoor Activity',
    description: 'Join us for an amazing evening outdoor activity focused on outdoor. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Yoga Studio',
    address: '271 Yoga Studio St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$10',
    attendees: 31,
    maxAttendees: 71,
    organizer: 'Wellness Network',
    tags: ["outdoor","evening","weekend"],
    website: 'https://example.com/wellness-outdoor-evening-weekend-171'
  },
  {
    id: 'wellness-outdoor-night-today-172',
    name: 'Today Night Outdoor Outdoor Activity',
    description: 'Join us for an amazing night outdoor activity focused on outdoor. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Sports Center',
    address: '272 Sports Center St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$15',
    attendees: 32,
    maxAttendees: 72,
    organizer: 'Wellness Network',
    tags: ["outdoor","night","today"],
    website: 'https://example.com/wellness-outdoor-night-today-172'
  },
  {
    id: 'wellness-outdoor-night-tomorrow-173',
    name: 'Tomorrow Night Outdoor Outdoor Activity',
    description: 'Join us for an amazing night outdoor activity focused on outdoor. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Wellness Center',
    address: '273 Wellness Center St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$20',
    attendees: 33,
    maxAttendees: 73,
    organizer: 'Wellness Network',
    tags: ["outdoor","night","tomorrow"],
    website: 'https://example.com/wellness-outdoor-night-tomorrow-173'
  },
  {
    id: 'wellness-outdoor-night-this week-174',
    name: 'This Week Night Outdoor Outdoor Activity',
    description: 'Join us for an amazing night outdoor activity focused on outdoor. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Outdoor Park',
    address: '274 Outdoor Park St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$25',
    attendees: 34,
    maxAttendees: 74,
    organizer: 'Wellness Network',
    tags: ["outdoor","night","this week"],
    website: 'https://example.com/wellness-outdoor-night-this week-174'
  },
  {
    id: 'wellness-outdoor-night-weekend-175',
    name: 'Weekend Night Outdoor Outdoor Activity',
    description: 'Join us for an amazing night outdoor activity focused on outdoor. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Outdoor',
    venue: 'Gym',
    address: '275 Gym St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$30',
    attendees: 35,
    maxAttendees: 75,
    organizer: 'Wellness Network',
    tags: ["outdoor","night","weekend"],
    website: 'https://example.com/wellness-outdoor-night-weekend-175'
  },
  {
    id: 'wellness-sports-morning-today-176',
    name: 'Today Morning Sports Sports Game',
    description: 'Join us for an amazing morning sports game focused on sports. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Yoga Studio',
    address: '276 Yoga Studio St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$35',
    attendees: 36,
    maxAttendees: 76,
    organizer: 'Wellness Network',
    tags: ["sports","morning","today"],
    website: 'https://example.com/wellness-sports-morning-today-176'
  },
  {
    id: 'wellness-sports-morning-tomorrow-177',
    name: 'Tomorrow Morning Sports Sports Game',
    description: 'Join us for an amazing morning sports game focused on sports. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Sports Center',
    address: '277 Sports Center St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$50',
    attendees: 37,
    maxAttendees: 77,
    organizer: 'Wellness Network',
    tags: ["sports","morning","tomorrow"],
    website: 'https://example.com/wellness-sports-morning-tomorrow-177'
  },
  {
    id: 'wellness-sports-morning-this week-178',
    name: 'This Week Morning Sports Sports Game',
    description: 'Join us for an amazing morning sports game focused on sports. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Wellness Center',
    address: '278 Wellness Center St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$75',
    attendees: 38,
    maxAttendees: 78,
    organizer: 'Wellness Network',
    tags: ["sports","morning","this week"],
    website: 'https://example.com/wellness-sports-morning-this week-178'
  },
  {
    id: 'wellness-sports-morning-weekend-179',
    name: 'Weekend Morning Sports Sports Game',
    description: 'Join us for an amazing morning sports game focused on sports. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Outdoor Park',
    address: '279 Outdoor Park St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$100',
    attendees: 39,
    maxAttendees: 79,
    organizer: 'Wellness Network',
    tags: ["sports","morning","weekend"],
    website: 'https://example.com/wellness-sports-morning-weekend-179'
  },
  {
    id: 'wellness-sports-afternoon-today-180',
    name: 'Today Afternoon Sports Sports Game',
    description: 'Join us for an amazing afternoon sports game focused on sports. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Gym',
    address: '280 Gym St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: 'Free',
    attendees: 40,
    maxAttendees: 80,
    organizer: 'Wellness Network',
    tags: ["sports","afternoon","today"],
    website: 'https://example.com/wellness-sports-afternoon-today-180'
  },
  {
    id: 'wellness-sports-afternoon-tomorrow-181',
    name: 'Tomorrow Afternoon Sports Sports Game',
    description: 'Join us for an amazing afternoon sports game focused on sports. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Yoga Studio',
    address: '281 Yoga Studio St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$10',
    attendees: 41,
    maxAttendees: 81,
    organizer: 'Wellness Network',
    tags: ["sports","afternoon","tomorrow"],
    website: 'https://example.com/wellness-sports-afternoon-tomorrow-181'
  },
  {
    id: 'wellness-sports-afternoon-this week-182',
    name: 'This Week Afternoon Sports Sports Game',
    description: 'Join us for an amazing afternoon sports game focused on sports. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Sports Center',
    address: '282 Sports Center St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$15',
    attendees: 42,
    maxAttendees: 82,
    organizer: 'Wellness Network',
    tags: ["sports","afternoon","this week"],
    website: 'https://example.com/wellness-sports-afternoon-this week-182'
  },
  {
    id: 'wellness-sports-afternoon-weekend-183',
    name: 'Weekend Afternoon Sports Sports Game',
    description: 'Join us for an amazing afternoon sports game focused on sports. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Wellness Center',
    address: '283 Wellness Center St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$20',
    attendees: 43,
    maxAttendees: 83,
    organizer: 'Wellness Network',
    tags: ["sports","afternoon","weekend"],
    website: 'https://example.com/wellness-sports-afternoon-weekend-183'
  },
  {
    id: 'wellness-sports-evening-today-184',
    name: 'Today Evening Sports Sports Game',
    description: 'Join us for an amazing evening sports game focused on sports. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Outdoor Park',
    address: '284 Outdoor Park St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$25',
    attendees: 44,
    maxAttendees: 84,
    organizer: 'Wellness Network',
    tags: ["sports","evening","today"],
    website: 'https://example.com/wellness-sports-evening-today-184'
  },
  {
    id: 'wellness-sports-evening-tomorrow-185',
    name: 'Tomorrow Evening Sports Sports Game',
    description: 'Join us for an amazing evening sports game focused on sports. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Gym',
    address: '285 Gym St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$30',
    attendees: 45,
    maxAttendees: 85,
    organizer: 'Wellness Network',
    tags: ["sports","evening","tomorrow"],
    website: 'https://example.com/wellness-sports-evening-tomorrow-185'
  },
  {
    id: 'wellness-sports-evening-this week-186',
    name: 'This Week Evening Sports Sports Game',
    description: 'Join us for an amazing evening sports game focused on sports. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Yoga Studio',
    address: '286 Yoga Studio St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$35',
    attendees: 46,
    maxAttendees: 86,
    organizer: 'Wellness Network',
    tags: ["sports","evening","this week"],
    website: 'https://example.com/wellness-sports-evening-this week-186'
  },
  {
    id: 'wellness-sports-evening-weekend-187',
    name: 'Weekend Evening Sports Sports Game',
    description: 'Join us for an amazing evening sports game focused on sports. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Sports Center',
    address: '287 Sports Center St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$50',
    attendees: 47,
    maxAttendees: 87,
    organizer: 'Wellness Network',
    tags: ["sports","evening","weekend"],
    website: 'https://example.com/wellness-sports-evening-weekend-187'
  },
  {
    id: 'wellness-sports-night-today-188',
    name: 'Today Night Sports Sports Game',
    description: 'Join us for an amazing night sports game focused on sports. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Wellness Center',
    address: '288 Wellness Center St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$75',
    attendees: 48,
    maxAttendees: 88,
    organizer: 'Wellness Network',
    tags: ["sports","night","today"],
    website: 'https://example.com/wellness-sports-night-today-188'
  },
  {
    id: 'wellness-sports-night-tomorrow-189',
    name: 'Tomorrow Night Sports Sports Game',
    description: 'Join us for an amazing night sports game focused on sports. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Outdoor Park',
    address: '289 Outdoor Park St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$100',
    attendees: 49,
    maxAttendees: 89,
    organizer: 'Wellness Network',
    tags: ["sports","night","tomorrow"],
    website: 'https://example.com/wellness-sports-night-tomorrow-189'
  },
  {
    id: 'wellness-sports-night-this week-190',
    name: 'This Week Night Sports Sports Game',
    description: 'Join us for an amazing night sports game focused on sports. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Gym',
    address: '290 Gym St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: 'Free',
    attendees: 50,
    maxAttendees: 90,
    organizer: 'Wellness Network',
    tags: ["sports","night","this week"],
    website: 'https://example.com/wellness-sports-night-this week-190'
  },
  {
    id: 'wellness-sports-night-weekend-191',
    name: 'Weekend Night Sports Sports Game',
    description: 'Join us for an amazing night sports game focused on sports. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Sports',
    venue: 'Yoga Studio',
    address: '291 Yoga Studio St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$10',
    attendees: 51,
    maxAttendees: 91,
    organizer: 'Wellness Network',
    tags: ["sports","night","weekend"],
    website: 'https://example.com/wellness-sports-night-weekend-191'
  },
  {
    id: 'wellness-mindfulness-morning-today-192',
    name: 'Today Morning Mindfulness Meditation',
    description: 'Join us for an amazing morning meditation focused on mindfulness. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Sports Center',
    address: '292 Sports Center St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$15',
    attendees: 52,
    maxAttendees: 92,
    organizer: 'Wellness Network',
    tags: ["mindfulness","morning","today"],
    website: 'https://example.com/wellness-mindfulness-morning-today-192'
  },
  {
    id: 'wellness-mindfulness-morning-tomorrow-193',
    name: 'Tomorrow Morning Mindfulness Meditation',
    description: 'Join us for an amazing morning meditation focused on mindfulness. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Wellness Center',
    address: '293 Wellness Center St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$20',
    attendees: 53,
    maxAttendees: 93,
    organizer: 'Wellness Network',
    tags: ["mindfulness","morning","tomorrow"],
    website: 'https://example.com/wellness-mindfulness-morning-tomorrow-193'
  },
  {
    id: 'wellness-mindfulness-morning-this week-194',
    name: 'This Week Morning Mindfulness Meditation',
    description: 'Join us for an amazing morning meditation focused on mindfulness. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Outdoor Park',
    address: '294 Outdoor Park St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$25',
    attendees: 54,
    maxAttendees: 94,
    organizer: 'Wellness Network',
    tags: ["mindfulness","morning","this week"],
    website: 'https://example.com/wellness-mindfulness-morning-this week-194'
  },
  {
    id: 'wellness-mindfulness-morning-weekend-195',
    name: 'Weekend Morning Mindfulness Meditation',
    description: 'Join us for an amazing morning meditation focused on mindfulness. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Gym',
    address: '295 Gym St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$30',
    attendees: 55,
    maxAttendees: 95,
    organizer: 'Wellness Network',
    tags: ["mindfulness","morning","weekend"],
    website: 'https://example.com/wellness-mindfulness-morning-weekend-195'
  },
  {
    id: 'wellness-mindfulness-afternoon-today-196',
    name: 'Today Afternoon Mindfulness Meditation',
    description: 'Join us for an amazing afternoon meditation focused on mindfulness. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Yoga Studio',
    address: '296 Yoga Studio St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$35',
    attendees: 56,
    maxAttendees: 96,
    organizer: 'Wellness Network',
    tags: ["mindfulness","afternoon","today"],
    website: 'https://example.com/wellness-mindfulness-afternoon-today-196'
  },
  {
    id: 'wellness-mindfulness-afternoon-tomorrow-197',
    name: 'Tomorrow Afternoon Mindfulness Meditation',
    description: 'Join us for an amazing afternoon meditation focused on mindfulness. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Sports Center',
    address: '297 Sports Center St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$50',
    attendees: 57,
    maxAttendees: 97,
    organizer: 'Wellness Network',
    tags: ["mindfulness","afternoon","tomorrow"],
    website: 'https://example.com/wellness-mindfulness-afternoon-tomorrow-197'
  },
  {
    id: 'wellness-mindfulness-afternoon-this week-198',
    name: 'This Week Afternoon Mindfulness Meditation',
    description: 'Join us for an amazing afternoon meditation focused on mindfulness. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Wellness Center',
    address: '298 Wellness Center St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$75',
    attendees: 58,
    maxAttendees: 98,
    organizer: 'Wellness Network',
    tags: ["mindfulness","afternoon","this week"],
    website: 'https://example.com/wellness-mindfulness-afternoon-this week-198'
  },
  {
    id: 'wellness-mindfulness-afternoon-weekend-199',
    name: 'Weekend Afternoon Mindfulness Meditation',
    description: 'Join us for an amazing afternoon meditation focused on mindfulness. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Outdoor Park',
    address: '299 Outdoor Park St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$100',
    attendees: 59,
    maxAttendees: 99,
    organizer: 'Wellness Network',
    tags: ["mindfulness","afternoon","weekend"],
    website: 'https://example.com/wellness-mindfulness-afternoon-weekend-199'
  },
  {
    id: 'wellness-mindfulness-evening-today-200',
    name: 'Today Evening Mindfulness Meditation',
    description: 'Join us for an amazing evening meditation focused on mindfulness. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Gym',
    address: '300 Gym St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: 'Free',
    attendees: 60,
    maxAttendees: 100,
    organizer: 'Wellness Network',
    tags: ["mindfulness","evening","today"],
    website: 'https://example.com/wellness-mindfulness-evening-today-200'
  },
  {
    id: 'wellness-mindfulness-evening-tomorrow-201',
    name: 'Tomorrow Evening Mindfulness Meditation',
    description: 'Join us for an amazing evening meditation focused on mindfulness. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Yoga Studio',
    address: '301 Yoga Studio St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$10',
    attendees: 61,
    maxAttendees: 101,
    organizer: 'Wellness Network',
    tags: ["mindfulness","evening","tomorrow"],
    website: 'https://example.com/wellness-mindfulness-evening-tomorrow-201'
  },
  {
    id: 'wellness-mindfulness-evening-this week-202',
    name: 'This Week Evening Mindfulness Meditation',
    description: 'Join us for an amazing evening meditation focused on mindfulness. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Sports Center',
    address: '302 Sports Center St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$15',
    attendees: 62,
    maxAttendees: 102,
    organizer: 'Wellness Network',
    tags: ["mindfulness","evening","this week"],
    website: 'https://example.com/wellness-mindfulness-evening-this week-202'
  },
  {
    id: 'wellness-mindfulness-evening-weekend-203',
    name: 'Weekend Evening Mindfulness Meditation',
    description: 'Join us for an amazing evening meditation focused on mindfulness. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Wellness Center',
    address: '303 Wellness Center St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$20',
    attendees: 63,
    maxAttendees: 103,
    organizer: 'Wellness Network',
    tags: ["mindfulness","evening","weekend"],
    website: 'https://example.com/wellness-mindfulness-evening-weekend-203'
  },
  {
    id: 'wellness-mindfulness-night-today-204',
    name: 'Today Night Mindfulness Meditation',
    description: 'Join us for an amazing night meditation focused on mindfulness. Perfect for today!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Outdoor Park',
    address: '304 Outdoor Park St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$25',
    attendees: 64,
    maxAttendees: 104,
    organizer: 'Wellness Network',
    tags: ["mindfulness","night","today"],
    website: 'https://example.com/wellness-mindfulness-night-today-204'
  },
  {
    id: 'wellness-mindfulness-night-tomorrow-205',
    name: 'Tomorrow Night Mindfulness Meditation',
    description: 'Join us for an amazing night meditation focused on mindfulness. Perfect for tomorrow!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Gym',
    address: '305 Gym St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$30',
    attendees: 65,
    maxAttendees: 105,
    organizer: 'Wellness Network',
    tags: ["mindfulness","night","tomorrow"],
    website: 'https://example.com/wellness-mindfulness-night-tomorrow-205'
  },
  {
    id: 'wellness-mindfulness-night-this week-206',
    name: 'This Week Night Mindfulness Meditation',
    description: 'Join us for an amazing night meditation focused on mindfulness. Perfect for this week!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Yoga Studio',
    address: '306 Yoga Studio St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$35',
    attendees: 66,
    maxAttendees: 106,
    organizer: 'Wellness Network',
    tags: ["mindfulness","night","this week"],
    website: 'https://example.com/wellness-mindfulness-night-this week-206'
  },
  {
    id: 'wellness-mindfulness-night-weekend-207',
    name: 'Weekend Night Mindfulness Meditation',
    description: 'Join us for an amazing night meditation focused on mindfulness. Perfect for weekend!',
    categoryPrimary: 'Wellness',
    categorySecondary: 'Mindfulness',
    venue: 'Sports Center',
    address: '307 Sports Center St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$50',
    attendees: 67,
    maxAttendees: 107,
    organizer: 'Wellness Network',
    tags: ["mindfulness","night","weekend"],
    website: 'https://example.com/wellness-mindfulness-night-weekend-207'
  },
  {
    id: 'professional-talks-morning-today-208',
    name: 'Today Morning Talks Talk',
    description: 'Join us for an amazing morning talk focused on talks. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Innovation Hub',
    address: '308 Innovation Hub St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$75',
    attendees: 68,
    maxAttendees: 108,
    organizer: 'Professional Network',
    tags: ["talks","morning","today"],
    website: 'https://example.com/professional-talks-morning-today-208'
  },
  {
    id: 'professional-talks-morning-tomorrow-209',
    name: 'Tomorrow Morning Talks Talk',
    description: 'Join us for an amazing morning talk focused on talks. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Meeting Room',
    address: '309 Meeting Room St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$100',
    attendees: 69,
    maxAttendees: 109,
    organizer: 'Professional Network',
    tags: ["talks","morning","tomorrow"],
    website: 'https://example.com/professional-talks-morning-tomorrow-209'
  },
  {
    id: 'professional-talks-morning-this week-210',
    name: 'This Week Morning Talks Talk',
    description: 'Join us for an amazing morning talk focused on talks. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Conference Center',
    address: '310 Conference Center St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: 'Free',
    attendees: 70,
    maxAttendees: 110,
    organizer: 'Professional Network',
    tags: ["talks","morning","this week"],
    website: 'https://example.com/professional-talks-morning-this week-210'
  },
  {
    id: 'professional-talks-morning-weekend-211',
    name: 'Weekend Morning Talks Talk',
    description: 'Join us for an amazing morning talk focused on talks. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Coworking Space',
    address: '311 Coworking Space St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$10',
    attendees: 71,
    maxAttendees: 111,
    organizer: 'Professional Network',
    tags: ["talks","morning","weekend"],
    website: 'https://example.com/professional-talks-morning-weekend-211'
  },
  {
    id: 'professional-talks-afternoon-today-212',
    name: 'Today Afternoon Talks Talk',
    description: 'Join us for an amazing afternoon talk focused on talks. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Business Center',
    address: '312 Business Center St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$15',
    attendees: 72,
    maxAttendees: 112,
    organizer: 'Professional Network',
    tags: ["talks","afternoon","today"],
    website: 'https://example.com/professional-talks-afternoon-today-212'
  },
  {
    id: 'professional-talks-afternoon-tomorrow-213',
    name: 'Tomorrow Afternoon Talks Talk',
    description: 'Join us for an amazing afternoon talk focused on talks. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Innovation Hub',
    address: '313 Innovation Hub St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$20',
    attendees: 73,
    maxAttendees: 113,
    organizer: 'Professional Network',
    tags: ["talks","afternoon","tomorrow"],
    website: 'https://example.com/professional-talks-afternoon-tomorrow-213'
  },
  {
    id: 'professional-talks-afternoon-this week-214',
    name: 'This Week Afternoon Talks Talk',
    description: 'Join us for an amazing afternoon talk focused on talks. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Meeting Room',
    address: '314 Meeting Room St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$25',
    attendees: 74,
    maxAttendees: 114,
    organizer: 'Professional Network',
    tags: ["talks","afternoon","this week"],
    website: 'https://example.com/professional-talks-afternoon-this week-214'
  },
  {
    id: 'professional-talks-afternoon-weekend-215',
    name: 'Weekend Afternoon Talks Talk',
    description: 'Join us for an amazing afternoon talk focused on talks. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Conference Center',
    address: '315 Conference Center St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$30',
    attendees: 75,
    maxAttendees: 115,
    organizer: 'Professional Network',
    tags: ["talks","afternoon","weekend"],
    website: 'https://example.com/professional-talks-afternoon-weekend-215'
  },
  {
    id: 'professional-talks-evening-today-216',
    name: 'Today Evening Talks Talk',
    description: 'Join us for an amazing evening talk focused on talks. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Coworking Space',
    address: '316 Coworking Space St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$35',
    attendees: 76,
    maxAttendees: 116,
    organizer: 'Professional Network',
    tags: ["talks","evening","today"],
    website: 'https://example.com/professional-talks-evening-today-216'
  },
  {
    id: 'professional-talks-evening-tomorrow-217',
    name: 'Tomorrow Evening Talks Talk',
    description: 'Join us for an amazing evening talk focused on talks. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Business Center',
    address: '317 Business Center St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$50',
    attendees: 77,
    maxAttendees: 117,
    organizer: 'Professional Network',
    tags: ["talks","evening","tomorrow"],
    website: 'https://example.com/professional-talks-evening-tomorrow-217'
  },
  {
    id: 'professional-talks-evening-this week-218',
    name: 'This Week Evening Talks Talk',
    description: 'Join us for an amazing evening talk focused on talks. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Innovation Hub',
    address: '318 Innovation Hub St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$75',
    attendees: 78,
    maxAttendees: 118,
    organizer: 'Professional Network',
    tags: ["talks","evening","this week"],
    website: 'https://example.com/professional-talks-evening-this week-218'
  },
  {
    id: 'professional-talks-evening-weekend-219',
    name: 'Weekend Evening Talks Talk',
    description: 'Join us for an amazing evening talk focused on talks. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Meeting Room',
    address: '319 Meeting Room St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$100',
    attendees: 79,
    maxAttendees: 119,
    organizer: 'Professional Network',
    tags: ["talks","evening","weekend"],
    website: 'https://example.com/professional-talks-evening-weekend-219'
  },
  {
    id: 'professional-talks-night-today-220',
    name: 'Today Night Talks Talk',
    description: 'Join us for an amazing night talk focused on talks. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Conference Center',
    address: '320 Conference Center St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: 'Free',
    attendees: 80,
    maxAttendees: 120,
    organizer: 'Professional Network',
    tags: ["talks","night","today"],
    website: 'https://example.com/professional-talks-night-today-220'
  },
  {
    id: 'professional-talks-night-tomorrow-221',
    name: 'Tomorrow Night Talks Talk',
    description: 'Join us for an amazing night talk focused on talks. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Coworking Space',
    address: '321 Coworking Space St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$10',
    attendees: 81,
    maxAttendees: 121,
    organizer: 'Professional Network',
    tags: ["talks","night","tomorrow"],
    website: 'https://example.com/professional-talks-night-tomorrow-221'
  },
  {
    id: 'professional-talks-night-this week-222',
    name: 'This Week Night Talks Talk',
    description: 'Join us for an amazing night talk focused on talks. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Business Center',
    address: '322 Business Center St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$15',
    attendees: 82,
    maxAttendees: 122,
    organizer: 'Professional Network',
    tags: ["talks","night","this week"],
    website: 'https://example.com/professional-talks-night-this week-222'
  },
  {
    id: 'professional-talks-night-weekend-223',
    name: 'Weekend Night Talks Talk',
    description: 'Join us for an amazing night talk focused on talks. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Talks',
    venue: 'Innovation Hub',
    address: '323 Innovation Hub St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$20',
    attendees: 83,
    maxAttendees: 123,
    organizer: 'Professional Network',
    tags: ["talks","night","weekend"],
    website: 'https://example.com/professional-talks-night-weekend-223'
  },
  {
    id: 'professional-workshops-morning-today-224',
    name: 'Today Morning Workshops Workshop',
    description: 'Join us for an amazing morning workshop focused on workshops. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Meeting Room',
    address: '324 Meeting Room St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$25',
    attendees: 84,
    maxAttendees: 124,
    organizer: 'Professional Network',
    tags: ["workshops","morning","today"],
    website: 'https://example.com/professional-workshops-morning-today-224'
  },
  {
    id: 'professional-workshops-morning-tomorrow-225',
    name: 'Tomorrow Morning Workshops Workshop',
    description: 'Join us for an amazing morning workshop focused on workshops. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Conference Center',
    address: '325 Conference Center St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$30',
    attendees: 85,
    maxAttendees: 125,
    organizer: 'Professional Network',
    tags: ["workshops","morning","tomorrow"],
    website: 'https://example.com/professional-workshops-morning-tomorrow-225'
  },
  {
    id: 'professional-workshops-morning-this week-226',
    name: 'This Week Morning Workshops Workshop',
    description: 'Join us for an amazing morning workshop focused on workshops. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Coworking Space',
    address: '326 Coworking Space St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$35',
    attendees: 86,
    maxAttendees: 126,
    organizer: 'Professional Network',
    tags: ["workshops","morning","this week"],
    website: 'https://example.com/professional-workshops-morning-this week-226'
  },
  {
    id: 'professional-workshops-morning-weekend-227',
    name: 'Weekend Morning Workshops Workshop',
    description: 'Join us for an amazing morning workshop focused on workshops. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Business Center',
    address: '327 Business Center St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$50',
    attendees: 87,
    maxAttendees: 127,
    organizer: 'Professional Network',
    tags: ["workshops","morning","weekend"],
    website: 'https://example.com/professional-workshops-morning-weekend-227'
  },
  {
    id: 'professional-workshops-afternoon-today-228',
    name: 'Today Afternoon Workshops Workshop',
    description: 'Join us for an amazing afternoon workshop focused on workshops. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Innovation Hub',
    address: '328 Innovation Hub St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$75',
    attendees: 88,
    maxAttendees: 128,
    organizer: 'Professional Network',
    tags: ["workshops","afternoon","today"],
    website: 'https://example.com/professional-workshops-afternoon-today-228'
  },
  {
    id: 'professional-workshops-afternoon-tomorrow-229',
    name: 'Tomorrow Afternoon Workshops Workshop',
    description: 'Join us for an amazing afternoon workshop focused on workshops. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Meeting Room',
    address: '329 Meeting Room St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$100',
    attendees: 89,
    maxAttendees: 129,
    organizer: 'Professional Network',
    tags: ["workshops","afternoon","tomorrow"],
    website: 'https://example.com/professional-workshops-afternoon-tomorrow-229'
  },
  {
    id: 'professional-workshops-afternoon-this week-230',
    name: 'This Week Afternoon Workshops Workshop',
    description: 'Join us for an amazing afternoon workshop focused on workshops. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Conference Center',
    address: '330 Conference Center St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: 'Free',
    attendees: 90,
    maxAttendees: 130,
    organizer: 'Professional Network',
    tags: ["workshops","afternoon","this week"],
    website: 'https://example.com/professional-workshops-afternoon-this week-230'
  },
  {
    id: 'professional-workshops-afternoon-weekend-231',
    name: 'Weekend Afternoon Workshops Workshop',
    description: 'Join us for an amazing afternoon workshop focused on workshops. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Coworking Space',
    address: '331 Coworking Space St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$10',
    attendees: 91,
    maxAttendees: 131,
    organizer: 'Professional Network',
    tags: ["workshops","afternoon","weekend"],
    website: 'https://example.com/professional-workshops-afternoon-weekend-231'
  },
  {
    id: 'professional-workshops-evening-today-232',
    name: 'Today Evening Workshops Workshop',
    description: 'Join us for an amazing evening workshop focused on workshops. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Business Center',
    address: '332 Business Center St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$15',
    attendees: 92,
    maxAttendees: 132,
    organizer: 'Professional Network',
    tags: ["workshops","evening","today"],
    website: 'https://example.com/professional-workshops-evening-today-232'
  },
  {
    id: 'professional-workshops-evening-tomorrow-233',
    name: 'Tomorrow Evening Workshops Workshop',
    description: 'Join us for an amazing evening workshop focused on workshops. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Innovation Hub',
    address: '333 Innovation Hub St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$20',
    attendees: 93,
    maxAttendees: 133,
    organizer: 'Professional Network',
    tags: ["workshops","evening","tomorrow"],
    website: 'https://example.com/professional-workshops-evening-tomorrow-233'
  },
  {
    id: 'professional-workshops-evening-this week-234',
    name: 'This Week Evening Workshops Workshop',
    description: 'Join us for an amazing evening workshop focused on workshops. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Meeting Room',
    address: '334 Meeting Room St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$25',
    attendees: 94,
    maxAttendees: 134,
    organizer: 'Professional Network',
    tags: ["workshops","evening","this week"],
    website: 'https://example.com/professional-workshops-evening-this week-234'
  },
  {
    id: 'professional-workshops-evening-weekend-235',
    name: 'Weekend Evening Workshops Workshop',
    description: 'Join us for an amazing evening workshop focused on workshops. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Conference Center',
    address: '335 Conference Center St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$30',
    attendees: 95,
    maxAttendees: 135,
    organizer: 'Professional Network',
    tags: ["workshops","evening","weekend"],
    website: 'https://example.com/professional-workshops-evening-weekend-235'
  },
  {
    id: 'professional-workshops-night-today-236',
    name: 'Today Night Workshops Workshop',
    description: 'Join us for an amazing night workshop focused on workshops. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Coworking Space',
    address: '336 Coworking Space St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$35',
    attendees: 96,
    maxAttendees: 136,
    organizer: 'Professional Network',
    tags: ["workshops","night","today"],
    website: 'https://example.com/professional-workshops-night-today-236'
  },
  {
    id: 'professional-workshops-night-tomorrow-237',
    name: 'Tomorrow Night Workshops Workshop',
    description: 'Join us for an amazing night workshop focused on workshops. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Business Center',
    address: '337 Business Center St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$50',
    attendees: 97,
    maxAttendees: 137,
    organizer: 'Professional Network',
    tags: ["workshops","night","tomorrow"],
    website: 'https://example.com/professional-workshops-night-tomorrow-237'
  },
  {
    id: 'professional-workshops-night-this week-238',
    name: 'This Week Night Workshops Workshop',
    description: 'Join us for an amazing night workshop focused on workshops. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Innovation Hub',
    address: '338 Innovation Hub St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$75',
    attendees: 98,
    maxAttendees: 138,
    organizer: 'Professional Network',
    tags: ["workshops","night","this week"],
    website: 'https://example.com/professional-workshops-night-this week-238'
  },
  {
    id: 'professional-workshops-night-weekend-239',
    name: 'Weekend Night Workshops Workshop',
    description: 'Join us for an amazing night workshop focused on workshops. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Workshops',
    venue: 'Meeting Room',
    address: '339 Meeting Room St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$100',
    attendees: 99,
    maxAttendees: 139,
    organizer: 'Professional Network',
    tags: ["workshops","night","weekend"],
    website: 'https://example.com/professional-workshops-night-weekend-239'
  },
  {
    id: 'professional-conferences-morning-today-240',
    name: 'Today Morning Conferences Conference',
    description: 'Join us for an amazing morning conference focused on conferences. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Conference Center',
    address: '340 Conference Center St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: 'Free',
    attendees: 20,
    maxAttendees: 140,
    organizer: 'Professional Network',
    tags: ["conferences","morning","today"],
    website: 'https://example.com/professional-conferences-morning-today-240'
  },
  {
    id: 'professional-conferences-morning-tomorrow-241',
    name: 'Tomorrow Morning Conferences Conference',
    description: 'Join us for an amazing morning conference focused on conferences. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Coworking Space',
    address: '341 Coworking Space St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$10',
    attendees: 21,
    maxAttendees: 141,
    organizer: 'Professional Network',
    tags: ["conferences","morning","tomorrow"],
    website: 'https://example.com/professional-conferences-morning-tomorrow-241'
  },
  {
    id: 'professional-conferences-morning-this week-242',
    name: 'This Week Morning Conferences Conference',
    description: 'Join us for an amazing morning conference focused on conferences. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Business Center',
    address: '342 Business Center St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$15',
    attendees: 22,
    maxAttendees: 142,
    organizer: 'Professional Network',
    tags: ["conferences","morning","this week"],
    website: 'https://example.com/professional-conferences-morning-this week-242'
  },
  {
    id: 'professional-conferences-morning-weekend-243',
    name: 'Weekend Morning Conferences Conference',
    description: 'Join us for an amazing morning conference focused on conferences. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Innovation Hub',
    address: '343 Innovation Hub St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$20',
    attendees: 23,
    maxAttendees: 143,
    organizer: 'Professional Network',
    tags: ["conferences","morning","weekend"],
    website: 'https://example.com/professional-conferences-morning-weekend-243'
  },
  {
    id: 'professional-conferences-afternoon-today-244',
    name: 'Today Afternoon Conferences Conference',
    description: 'Join us for an amazing afternoon conference focused on conferences. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Meeting Room',
    address: '344 Meeting Room St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$25',
    attendees: 24,
    maxAttendees: 144,
    organizer: 'Professional Network',
    tags: ["conferences","afternoon","today"],
    website: 'https://example.com/professional-conferences-afternoon-today-244'
  },
  {
    id: 'professional-conferences-afternoon-tomorrow-245',
    name: 'Tomorrow Afternoon Conferences Conference',
    description: 'Join us for an amazing afternoon conference focused on conferences. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Conference Center',
    address: '345 Conference Center St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$30',
    attendees: 25,
    maxAttendees: 145,
    organizer: 'Professional Network',
    tags: ["conferences","afternoon","tomorrow"],
    website: 'https://example.com/professional-conferences-afternoon-tomorrow-245'
  },
  {
    id: 'professional-conferences-afternoon-this week-246',
    name: 'This Week Afternoon Conferences Conference',
    description: 'Join us for an amazing afternoon conference focused on conferences. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Coworking Space',
    address: '346 Coworking Space St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$35',
    attendees: 26,
    maxAttendees: 146,
    organizer: 'Professional Network',
    tags: ["conferences","afternoon","this week"],
    website: 'https://example.com/professional-conferences-afternoon-this week-246'
  },
  {
    id: 'professional-conferences-afternoon-weekend-247',
    name: 'Weekend Afternoon Conferences Conference',
    description: 'Join us for an amazing afternoon conference focused on conferences. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Business Center',
    address: '347 Business Center St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$50',
    attendees: 27,
    maxAttendees: 147,
    organizer: 'Professional Network',
    tags: ["conferences","afternoon","weekend"],
    website: 'https://example.com/professional-conferences-afternoon-weekend-247'
  },
  {
    id: 'professional-conferences-evening-today-248',
    name: 'Today Evening Conferences Conference',
    description: 'Join us for an amazing evening conference focused on conferences. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Innovation Hub',
    address: '348 Innovation Hub St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$75',
    attendees: 28,
    maxAttendees: 148,
    organizer: 'Professional Network',
    tags: ["conferences","evening","today"],
    website: 'https://example.com/professional-conferences-evening-today-248'
  },
  {
    id: 'professional-conferences-evening-tomorrow-249',
    name: 'Tomorrow Evening Conferences Conference',
    description: 'Join us for an amazing evening conference focused on conferences. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Meeting Room',
    address: '349 Meeting Room St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$100',
    attendees: 29,
    maxAttendees: 149,
    organizer: 'Professional Network',
    tags: ["conferences","evening","tomorrow"],
    website: 'https://example.com/professional-conferences-evening-tomorrow-249'
  },
  {
    id: 'professional-conferences-evening-this week-250',
    name: 'This Week Evening Conferences Conference',
    description: 'Join us for an amazing evening conference focused on conferences. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Conference Center',
    address: '350 Conference Center St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: 'Free',
    attendees: 30,
    maxAttendees: 150,
    organizer: 'Professional Network',
    tags: ["conferences","evening","this week"],
    website: 'https://example.com/professional-conferences-evening-this week-250'
  },
  {
    id: 'professional-conferences-evening-weekend-251',
    name: 'Weekend Evening Conferences Conference',
    description: 'Join us for an amazing evening conference focused on conferences. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Coworking Space',
    address: '351 Coworking Space St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$10',
    attendees: 31,
    maxAttendees: 151,
    organizer: 'Professional Network',
    tags: ["conferences","evening","weekend"],
    website: 'https://example.com/professional-conferences-evening-weekend-251'
  },
  {
    id: 'professional-conferences-night-today-252',
    name: 'Today Night Conferences Conference',
    description: 'Join us for an amazing night conference focused on conferences. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Business Center',
    address: '352 Business Center St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$15',
    attendees: 32,
    maxAttendees: 152,
    organizer: 'Professional Network',
    tags: ["conferences","night","today"],
    website: 'https://example.com/professional-conferences-night-today-252'
  },
  {
    id: 'professional-conferences-night-tomorrow-253',
    name: 'Tomorrow Night Conferences Conference',
    description: 'Join us for an amazing night conference focused on conferences. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Innovation Hub',
    address: '353 Innovation Hub St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$20',
    attendees: 33,
    maxAttendees: 153,
    organizer: 'Professional Network',
    tags: ["conferences","night","tomorrow"],
    website: 'https://example.com/professional-conferences-night-tomorrow-253'
  },
  {
    id: 'professional-conferences-night-this week-254',
    name: 'This Week Night Conferences Conference',
    description: 'Join us for an amazing night conference focused on conferences. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Meeting Room',
    address: '354 Meeting Room St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$25',
    attendees: 34,
    maxAttendees: 154,
    organizer: 'Professional Network',
    tags: ["conferences","night","this week"],
    website: 'https://example.com/professional-conferences-night-this week-254'
  },
  {
    id: 'professional-conferences-night-weekend-255',
    name: 'Weekend Night Conferences Conference',
    description: 'Join us for an amazing night conference focused on conferences. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Conferences',
    venue: 'Conference Center',
    address: '355 Conference Center St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$30',
    attendees: 35,
    maxAttendees: 155,
    organizer: 'Professional Network',
    tags: ["conferences","night","weekend"],
    website: 'https://example.com/professional-conferences-night-weekend-255'
  },
  {
    id: 'professional-networking-morning-today-256',
    name: 'Today Morning Networking Networking',
    description: 'Join us for an amazing morning networking focused on networking. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Coworking Space',
    address: '356 Coworking Space St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$35',
    attendees: 36,
    maxAttendees: 156,
    organizer: 'Professional Network',
    tags: ["networking","morning","today"],
    website: 'https://example.com/professional-networking-morning-today-256'
  },
  {
    id: 'professional-networking-morning-tomorrow-257',
    name: 'Tomorrow Morning Networking Networking',
    description: 'Join us for an amazing morning networking focused on networking. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Business Center',
    address: '357 Business Center St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$50',
    attendees: 37,
    maxAttendees: 157,
    organizer: 'Professional Network',
    tags: ["networking","morning","tomorrow"],
    website: 'https://example.com/professional-networking-morning-tomorrow-257'
  },
  {
    id: 'professional-networking-morning-this week-258',
    name: 'This Week Morning Networking Networking',
    description: 'Join us for an amazing morning networking focused on networking. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Innovation Hub',
    address: '358 Innovation Hub St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$75',
    attendees: 38,
    maxAttendees: 158,
    organizer: 'Professional Network',
    tags: ["networking","morning","this week"],
    website: 'https://example.com/professional-networking-morning-this week-258'
  },
  {
    id: 'professional-networking-morning-weekend-259',
    name: 'Weekend Morning Networking Networking',
    description: 'Join us for an amazing morning networking focused on networking. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Meeting Room',
    address: '359 Meeting Room St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$100',
    attendees: 39,
    maxAttendees: 159,
    organizer: 'Professional Network',
    tags: ["networking","morning","weekend"],
    website: 'https://example.com/professional-networking-morning-weekend-259'
  },
  {
    id: 'professional-networking-afternoon-today-260',
    name: 'Today Afternoon Networking Networking',
    description: 'Join us for an amazing afternoon networking focused on networking. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Conference Center',
    address: '360 Conference Center St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: 'Free',
    attendees: 40,
    maxAttendees: 160,
    organizer: 'Professional Network',
    tags: ["networking","afternoon","today"],
    website: 'https://example.com/professional-networking-afternoon-today-260'
  },
  {
    id: 'professional-networking-afternoon-tomorrow-261',
    name: 'Tomorrow Afternoon Networking Networking',
    description: 'Join us for an amazing afternoon networking focused on networking. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Coworking Space',
    address: '361 Coworking Space St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$10',
    attendees: 41,
    maxAttendees: 161,
    organizer: 'Professional Network',
    tags: ["networking","afternoon","tomorrow"],
    website: 'https://example.com/professional-networking-afternoon-tomorrow-261'
  },
  {
    id: 'professional-networking-afternoon-this week-262',
    name: 'This Week Afternoon Networking Networking',
    description: 'Join us for an amazing afternoon networking focused on networking. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Business Center',
    address: '362 Business Center St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$15',
    attendees: 42,
    maxAttendees: 162,
    organizer: 'Professional Network',
    tags: ["networking","afternoon","this week"],
    website: 'https://example.com/professional-networking-afternoon-this week-262'
  },
  {
    id: 'professional-networking-afternoon-weekend-263',
    name: 'Weekend Afternoon Networking Networking',
    description: 'Join us for an amazing afternoon networking focused on networking. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Innovation Hub',
    address: '363 Innovation Hub St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$20',
    attendees: 43,
    maxAttendees: 163,
    organizer: 'Professional Network',
    tags: ["networking","afternoon","weekend"],
    website: 'https://example.com/professional-networking-afternoon-weekend-263'
  },
  {
    id: 'professional-networking-evening-today-264',
    name: 'Today Evening Networking Networking',
    description: 'Join us for an amazing evening networking focused on networking. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Meeting Room',
    address: '364 Meeting Room St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: '$25',
    attendees: 44,
    maxAttendees: 164,
    organizer: 'Professional Network',
    tags: ["networking","evening","today"],
    website: 'https://example.com/professional-networking-evening-today-264'
  },
  {
    id: 'professional-networking-evening-tomorrow-265',
    name: 'Tomorrow Evening Networking Networking',
    description: 'Join us for an amazing evening networking focused on networking. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Conference Center',
    address: '365 Conference Center St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$30',
    attendees: 45,
    maxAttendees: 165,
    organizer: 'Professional Network',
    tags: ["networking","evening","tomorrow"],
    website: 'https://example.com/professional-networking-evening-tomorrow-265'
  },
  {
    id: 'professional-networking-evening-this week-266',
    name: 'This Week Evening Networking Networking',
    description: 'Join us for an amazing evening networking focused on networking. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Coworking Space',
    address: '366 Coworking Space St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$35',
    attendees: 46,
    maxAttendees: 166,
    organizer: 'Professional Network',
    tags: ["networking","evening","this week"],
    website: 'https://example.com/professional-networking-evening-this week-266'
  },
  {
    id: 'professional-networking-evening-weekend-267',
    name: 'Weekend Evening Networking Networking',
    description: 'Join us for an amazing evening networking focused on networking. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Business Center',
    address: '367 Business Center St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$50',
    attendees: 47,
    maxAttendees: 167,
    organizer: 'Professional Network',
    tags: ["networking","evening","weekend"],
    website: 'https://example.com/professional-networking-evening-weekend-267'
  },
  {
    id: 'professional-networking-night-today-268',
    name: 'Today Night Networking Networking',
    description: 'Join us for an amazing night networking focused on networking. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Innovation Hub',
    address: '368 Innovation Hub St, San Francisco, CA',
    latitude: 37.764900000000004,
    longitude: -122.4044,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$75',
    attendees: 48,
    maxAttendees: 168,
    organizer: 'Professional Network',
    tags: ["networking","night","today"],
    website: 'https://example.com/professional-networking-night-today-268'
  },
  {
    id: 'professional-networking-night-tomorrow-269',
    name: 'Tomorrow Night Networking Networking',
    description: 'Join us for an amazing night networking focused on networking. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Meeting Room',
    address: '369 Meeting Room St, San Francisco, CA',
    latitude: 37.76990000000001,
    longitude: -122.3994,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$100',
    attendees: 49,
    maxAttendees: 169,
    organizer: 'Professional Network',
    tags: ["networking","night","tomorrow"],
    website: 'https://example.com/professional-networking-night-tomorrow-269'
  },
  {
    id: 'professional-networking-night-this week-270',
    name: 'This Week Night Networking Networking',
    description: 'Join us for an amazing night networking focused on networking. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Conference Center',
    address: '370 Conference Center St, San Francisco, CA',
    latitude: 37.7749,
    longitude: -122.4444,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: 'Free',
    attendees: 50,
    maxAttendees: 170,
    organizer: 'Professional Network',
    tags: ["networking","night","this week"],
    website: 'https://example.com/professional-networking-night-this week-270'
  },
  {
    id: 'professional-networking-night-weekend-271',
    name: 'Weekend Night Networking Networking',
    description: 'Join us for an amazing night networking focused on networking. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Networking',
    venue: 'Coworking Space',
    address: '371 Coworking Space St, San Francisco, CA',
    latitude: 37.779900000000005,
    longitude: -122.4394,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$10',
    attendees: 51,
    maxAttendees: 171,
    organizer: 'Professional Network',
    tags: ["networking","night","weekend"],
    website: 'https://example.com/professional-networking-night-weekend-271'
  },
  {
    id: 'professional-mentorship-morning-today-272',
    name: 'Today Morning Mentorship Mentorship',
    description: 'Join us for an amazing morning mentorship focused on mentorship. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Business Center',
    address: '372 Business Center St, San Francisco, CA',
    latitude: 37.78490000000001,
    longitude: -122.4344,
    time: 'Morning',
    day: 'Today',
    date: '2025-10-17',
    startTime: '08:00',
    endTime: '12:00',
    price: '$15',
    attendees: 52,
    maxAttendees: 172,
    organizer: 'Professional Network',
    tags: ["mentorship","morning","today"],
    website: 'https://example.com/professional-mentorship-morning-today-272'
  },
  {
    id: 'professional-mentorship-morning-tomorrow-273',
    name: 'Tomorrow Morning Mentorship Mentorship',
    description: 'Join us for an amazing morning mentorship focused on mentorship. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Innovation Hub',
    address: '373 Innovation Hub St, San Francisco, CA',
    latitude: 37.7899,
    longitude: -122.4294,
    time: 'Morning',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '08:00',
    endTime: '12:00',
    price: '$20',
    attendees: 53,
    maxAttendees: 173,
    organizer: 'Professional Network',
    tags: ["mentorship","morning","tomorrow"],
    website: 'https://example.com/professional-mentorship-morning-tomorrow-273'
  },
  {
    id: 'professional-mentorship-morning-this week-274',
    name: 'This Week Morning Mentorship Mentorship',
    description: 'Join us for an amazing morning mentorship focused on mentorship. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Meeting Room',
    address: '374 Meeting Room St, San Francisco, CA',
    latitude: 37.794900000000005,
    longitude: -122.4244,
    time: 'Morning',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '08:00',
    endTime: '12:00',
    price: '$25',
    attendees: 54,
    maxAttendees: 174,
    organizer: 'Professional Network',
    tags: ["mentorship","morning","this week"],
    website: 'https://example.com/professional-mentorship-morning-this week-274'
  },
  {
    id: 'professional-mentorship-morning-weekend-275',
    name: 'Weekend Morning Mentorship Mentorship',
    description: 'Join us for an amazing morning mentorship focused on mentorship. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Conference Center',
    address: '375 Conference Center St, San Francisco, CA',
    latitude: 37.79990000000001,
    longitude: -122.4194,
    time: 'Morning',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '08:00',
    endTime: '12:00',
    price: '$30',
    attendees: 55,
    maxAttendees: 175,
    organizer: 'Professional Network',
    tags: ["mentorship","morning","weekend"],
    website: 'https://example.com/professional-mentorship-morning-weekend-275'
  },
  {
    id: 'professional-mentorship-afternoon-today-276',
    name: 'Today Afternoon Mentorship Mentorship',
    description: 'Join us for an amazing afternoon mentorship focused on mentorship. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Coworking Space',
    address: '376 Coworking Space St, San Francisco, CA',
    latitude: 37.8049,
    longitude: -122.4144,
    time: 'Afternoon',
    day: 'Today',
    date: '2025-10-17',
    startTime: '13:00',
    endTime: '17:00',
    price: '$35',
    attendees: 56,
    maxAttendees: 176,
    organizer: 'Professional Network',
    tags: ["mentorship","afternoon","today"],
    website: 'https://example.com/professional-mentorship-afternoon-today-276'
  },
  {
    id: 'professional-mentorship-afternoon-tomorrow-277',
    name: 'Tomorrow Afternoon Mentorship Mentorship',
    description: 'Join us for an amazing afternoon mentorship focused on mentorship. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Business Center',
    address: '377 Business Center St, San Francisco, CA',
    latitude: 37.809900000000006,
    longitude: -122.4094,
    time: 'Afternoon',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '13:00',
    endTime: '17:00',
    price: '$50',
    attendees: 57,
    maxAttendees: 177,
    organizer: 'Professional Network',
    tags: ["mentorship","afternoon","tomorrow"],
    website: 'https://example.com/professional-mentorship-afternoon-tomorrow-277'
  },
  {
    id: 'professional-mentorship-afternoon-this week-278',
    name: 'This Week Afternoon Mentorship Mentorship',
    description: 'Join us for an amazing afternoon mentorship focused on mentorship. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Innovation Hub',
    address: '378 Innovation Hub St, San Francisco, CA',
    latitude: 37.81490000000001,
    longitude: -122.4044,
    time: 'Afternoon',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '13:00',
    endTime: '17:00',
    price: '$75',
    attendees: 58,
    maxAttendees: 178,
    organizer: 'Professional Network',
    tags: ["mentorship","afternoon","this week"],
    website: 'https://example.com/professional-mentorship-afternoon-this week-278'
  },
  {
    id: 'professional-mentorship-afternoon-weekend-279',
    name: 'Weekend Afternoon Mentorship Mentorship',
    description: 'Join us for an amazing afternoon mentorship focused on mentorship. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Meeting Room',
    address: '379 Meeting Room St, San Francisco, CA',
    latitude: 37.819900000000004,
    longitude: -122.3994,
    time: 'Afternoon',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '13:00',
    endTime: '17:00',
    price: '$100',
    attendees: 59,
    maxAttendees: 179,
    organizer: 'Professional Network',
    tags: ["mentorship","afternoon","weekend"],
    website: 'https://example.com/professional-mentorship-afternoon-weekend-279'
  },
  {
    id: 'professional-mentorship-evening-today-280',
    name: 'Today Evening Mentorship Mentorship',
    description: 'Join us for an amazing evening mentorship focused on mentorship. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Conference Center',
    address: '380 Conference Center St, San Francisco, CA',
    latitude: 37.724900000000005,
    longitude: -122.4444,
    time: 'Evening',
    day: 'Today',
    date: '2025-10-17',
    startTime: '18:00',
    endTime: '22:00',
    price: 'Free',
    attendees: 60,
    maxAttendees: 180,
    organizer: 'Professional Network',
    tags: ["mentorship","evening","today"],
    website: 'https://example.com/professional-mentorship-evening-today-280'
  },
  {
    id: 'professional-mentorship-evening-tomorrow-281',
    name: 'Tomorrow Evening Mentorship Mentorship',
    description: 'Join us for an amazing evening mentorship focused on mentorship. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Coworking Space',
    address: '381 Coworking Space St, San Francisco, CA',
    latitude: 37.72990000000001,
    longitude: -122.4394,
    time: 'Evening',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '18:00',
    endTime: '22:00',
    price: '$10',
    attendees: 61,
    maxAttendees: 181,
    organizer: 'Professional Network',
    tags: ["mentorship","evening","tomorrow"],
    website: 'https://example.com/professional-mentorship-evening-tomorrow-281'
  },
  {
    id: 'professional-mentorship-evening-this week-282',
    name: 'This Week Evening Mentorship Mentorship',
    description: 'Join us for an amazing evening mentorship focused on mentorship. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Business Center',
    address: '382 Business Center St, San Francisco, CA',
    latitude: 37.7349,
    longitude: -122.4344,
    time: 'Evening',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '18:00',
    endTime: '22:00',
    price: '$15',
    attendees: 62,
    maxAttendees: 182,
    organizer: 'Professional Network',
    tags: ["mentorship","evening","this week"],
    website: 'https://example.com/professional-mentorship-evening-this week-282'
  },
  {
    id: 'professional-mentorship-evening-weekend-283',
    name: 'Weekend Evening Mentorship Mentorship',
    description: 'Join us for an amazing evening mentorship focused on mentorship. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Innovation Hub',
    address: '383 Innovation Hub St, San Francisco, CA',
    latitude: 37.739900000000006,
    longitude: -122.4294,
    time: 'Evening',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '18:00',
    endTime: '22:00',
    price: '$20',
    attendees: 63,
    maxAttendees: 183,
    organizer: 'Professional Network',
    tags: ["mentorship","evening","weekend"],
    website: 'https://example.com/professional-mentorship-evening-weekend-283'
  },
  {
    id: 'professional-mentorship-night-today-284',
    name: 'Today Night Mentorship Mentorship',
    description: 'Join us for an amazing night mentorship focused on mentorship. Perfect for today!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Meeting Room',
    address: '384 Meeting Room St, San Francisco, CA',
    latitude: 37.74490000000001,
    longitude: -122.4244,
    time: 'Night',
    day: 'Today',
    date: '2025-10-17',
    startTime: '22:00',
    endTime: '02:00',
    price: '$25',
    attendees: 64,
    maxAttendees: 184,
    organizer: 'Professional Network',
    tags: ["mentorship","night","today"],
    website: 'https://example.com/professional-mentorship-night-today-284'
  },
  {
    id: 'professional-mentorship-night-tomorrow-285',
    name: 'Tomorrow Night Mentorship Mentorship',
    description: 'Join us for an amazing night mentorship focused on mentorship. Perfect for tomorrow!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Conference Center',
    address: '385 Conference Center St, San Francisco, CA',
    latitude: 37.749900000000004,
    longitude: -122.4194,
    time: 'Night',
    day: 'Tomorrow',
    date: '2025-10-18',
    startTime: '22:00',
    endTime: '02:00',
    price: '$30',
    attendees: 65,
    maxAttendees: 185,
    organizer: 'Professional Network',
    tags: ["mentorship","night","tomorrow"],
    website: 'https://example.com/professional-mentorship-night-tomorrow-285'
  },
  {
    id: 'professional-mentorship-night-this week-286',
    name: 'This Week Night Mentorship Mentorship',
    description: 'Join us for an amazing night mentorship focused on mentorship. Perfect for this week!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Coworking Space',
    address: '386 Coworking Space St, San Francisco, CA',
    latitude: 37.754900000000006,
    longitude: -122.4144,
    time: 'Night',
    day: 'This Week',
    date: '2025-10-20',
    startTime: '22:00',
    endTime: '02:00',
    price: '$35',
    attendees: 66,
    maxAttendees: 186,
    organizer: 'Professional Network',
    tags: ["mentorship","night","this week"],
    website: 'https://example.com/professional-mentorship-night-this week-286'
  },
  {
    id: 'professional-mentorship-night-weekend-287',
    name: 'Weekend Night Mentorship Mentorship',
    description: 'Join us for an amazing night mentorship focused on mentorship. Perfect for weekend!',
    categoryPrimary: 'Professional',
    categorySecondary: 'Mentorship',
    venue: 'Business Center',
    address: '387 Business Center St, San Francisco, CA',
    latitude: 37.7599,
    longitude: -122.4094,
    time: 'Night',
    day: 'Weekend',
    date: '2025-10-19',
    startTime: '22:00',
    endTime: '02:00',
    price: '$50',
    attendees: 67,
    maxAttendees: 187,
    organizer: 'Professional Network',
    tags: ["mentorship","night","weekend"],
    website: 'https://example.com/professional-mentorship-night-weekend-287'
  }
];

// Merge sample events with real DC events
export const COMPREHENSIVE_SAMPLE_EVENTS = [
  ...SAMPLE_EVENTS,
  ...DC_REAL_EVENTS
];

// Log event counts
console.log(`📊 Total events loaded: ${COMPREHENSIVE_SAMPLE_EVENTS.length} (${SAMPLE_EVENTS.length} sample + ${DC_REAL_EVENTS.length} real DC events)`);

// Filter Options
export const FILTER_OPTIONS = {
  time: ['All', 'Morning', 'Afternoon', 'Evening', 'Night'],
  day: ['All', 'Today', 'Tomorrow', 'This Week', 'Weekend'],
  category: ['All', 'Social', 'Arts/Culture', 'Wellness', 'Professional']
};

// Default Filters
export const DEFAULT_FILTERS = {
  time: 'All',
  day: 'All',
  category: 'All'
};

// Filter Events Function
export function filterEvents(events, filters) {
  return events.filter(event => {
    // Category filter
    if (filters.category && filters.category !== 'All' && event.categoryPrimary !== filters.category) {
      return false;
    }
    
    // Time filter
    if (filters.time && filters.time !== 'All' && event.time !== filters.time) {
      return false;
    }
    
    // Day filter
    if (filters.day && filters.day !== 'All' && event.day !== filters.day) {
      return false;
    }
    
    return true;
  });
}
